import React, { Fragment } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import { Card, CardBody, CardHeader, Col, Container, Row, Label, Collapse, Table, Nav, NavItem, NavLink, TabContent, TabPane, Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';
import BreadCrumb from '../components/Common/BreadCrumb';
import Flatpickr from "react-flatpickr";
import dateFormat from "dateformat";
import moment from "moment";
import { Typeahead } from 'react-bootstrap-typeahead';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import Select from 'react-select';

import { createDeepClone } from "../utils/index";

import CardLoader from "../components/CardLoader";
import ActionList from "../components/ActionList";
import Lookup from "../components/Lookup";
import CustomerLookup from "../components/CustomerLookup";
import IsoRequestGrid from "../components/IsoRequestGrid";
import IsoRelatedRequestList from "../components/IsoRelatedRequestList";
import { Highlighter, Menu, MenuItem } from 'react-bootstrap-typeahead';
import ConfirmModal from "../components/ConfirmModal";
import ConfirmModalAdvanced from "../components/ConfirmModalAdvanced";
import IsoServiceDocumentGrid from "../components/IsoServiceDocumentGrid";
import CommentGrid from "../components/CommentGrid";
import ErrorModal from "../components/ErrorModal";
import MyNumberRenderer from "../components/MyNumberRenderer";

import { useDispatch, useSelector } from "react-redux";
import * as isoRequestActions from "../actions/IsoRequestActions";
import * as commonActions from "../actions/CommonActions";

const IsoRequestEditScreen  = (props) => {
    const { register, clearErrors, reset, trigger, formState: { errors } } = useForm({mode: 'all'});

    const navigate = useNavigate();
    const { id } = useParams();

    const dispatch = useDispatch();

    const loading = useSelector((state) => state.iso.loadingFBO);
    const loadingInvoice = useSelector((state) => state.iso.loadingInvoice);
    const user = useSelector((state) => state.login.user);
    const fbo = useSelector((state) => state.iso.fbo);
    const invoiceFBO = useSelector((state) => state.iso.invoiceFBO);

    const [fboState, setFBOState] = React.useState(fbo);
    const [isDirty, setIsDirty] = React.useState(false);
    const [refreshAction, setRefreshAction] = React.useState(false);
    const [selectedReporter, setSelectedReporter] = React.useState([]);
    const [selectedCustomer, setSelectedCustomer] = React.useState([]);
    const [invoiceInformationCollapsed, setInvoiceInformationCollapsed] = React.useState(true);
    const [relatedIsoRequestCollapsed, setRelatedIsoRequestCollapsed] = React.useState(true);
    
    const [isContainer, setIsContainer] = React.useState(false);
    const [isChild, setIsChild] = React.useState(false);
    const [isTicket, setIsTicket] = React.useState(false);

    const [loadingLocal, setLoadingLocal] = React.useState(false);
    const [loadingStarted, setLoadingStarted] = React.useState(false);
    const [selectedStatus, setSelectedStatus] = React.useState("");
    const [currentMessage, setCurrentMessage] = React.useState("");    
    const [showSubmitModal, setShowSubmitModal] = React.useState(false);
    const [showSalesActionModal, setShowSalesActionModal] = React.useState(false);
    const [showNewModal, setShowNewModal] = React.useState(false);
    const [showCalculateManDaysModal, setShowCalculateManDaysModal] = React.useState(false);    
    const [showSchedulingModal, setShowSchedulingModal] = React.useState(false);
    const [showAuditInProgressModal, setShowAuditInProgressModal] = React.useState(false);
    const [showDocumentReviewModal, setShowDocumentReviewModal] = React.useState(false);
    const [showTechnicalReviewModal, setShowTechnicalReviewModal] = React.useState(false);
    const [showDecisionMakingModal, setShowDecisionMakingModal] = React.useState(false);
    const [showCertificateGenerationModal, setShowCertificateGenerationModal] = React.useState(false);
    const [showCompletedModal, setShowCompletedModal] = React.useState(false);
    const [showClosedModal, setShowClosedModal] = React.useState(false);
    const [showAbortedModal, setShowAbortedModal] = React.useState(false);
    const [showResetToDraftModal, setShowResetToDraftModal] = React.useState(false);
    const [showAssignMeModal, setShowAssignMeModal] = React.useState(false);
    const [showProceedWithoutPaymentModal, setShowProceedWithoutPaymentModal] = React.useState(false);
    const [showNotifyProceedWithoutPaymentModal, setShowNotifyProceedWithoutPaymentModal] = React.useState(false);
    const [showGenerateCertificateModal, setShowGenerateCertificateModal] = React.useState(false);
    const [showGenerateCertificateDownloadModal, setShowGenerateCertificateDownloadModal] = React.useState(false);
    const [generateCertificateId, setGenerateCertificateId] = React.useState(false);
    const [generateCertificateErrorMessages, setGenerateCertificateErrorMessages] = React.useState([]);
    const [showGenerateMdcModal, setShowGenerateMdcModal] = React.useState(false);
    const [showGenerateMdcDownloadModal, setShowGenerateMdcDownloadModal] = React.useState(false);
    const [generateMdcId, setGenerateMdcId] = React.useState(false);
    const [showInvoiceViewModal, setShowInvoiceViewModal] = React.useState(false);
    const [showRemoveInvoiceModal, setShowRemoveInvoiceModal] = React.useState(false);
    const [removeInvoiceId, setRemoveInvoiceId] = React.useState("");
    
    const [activeTab, setActiveTab] = React.useState(0);
    const [newRequestType, setNewRequestType] = React.useState("");
    const [newRequestTypeOther, setNewRequestTypeOther] = React.useState("");
    const [newCertificateNumber, setNewCertificateNumber] = React.useState("");
    const [newAccreditationType, setNewAccreditationType] = React.useState("");
    const [newManDayStandardId, setNewManDayStandardId] = React.useState("");
    const [showAddCertificateModal, setShowAddCertificateModal] = React.useState(false);
    const [showRemoveCertificateModal, setShowRemoveCertificateModal] = React.useState(false);
    const [removeCertificateId, setRemoveCertificateId] = React.useState("");

    const [autoStatusChangeShown, setAutoStatusChangeShown] = React.useState(false);
    const [autoStatusNextStatus, setAutoStatusNextStatus] = React.useState("");
    const [showAutoStatusChangeModal, setShowAutoStatusChangeModal] = React.useState(false);

    const toggleTab = (tab) => {
        if (activeTab !== tab) {
            setActiveTab(tab);
        }
    };

    React.useEffect(() => {
	    dispatch(isoRequestActions.loadIsoRequest(id, navigate));
        setLoadingStarted(true);
    }, [id]);

    React.useEffect(() => {
		setFBOState(fbo);
        setIsDirty(false);
        setRefreshAction(!refreshAction);
        setSelectedReporter([]);
        setSelectedCustomer([]);

        setIsContainer(false);
        setIsChild(false);
        setIsTicket(false);

        if(fbo) {
            if(fbo.isoRequest.ticketType === "CONTAINER") {
                setIsContainer(true);
            }
            else if(fbo.isoRequest.ticketType === "CHILD") {
                setIsChild(true);
            }
            else if(fbo.isoRequest.ticketType === "TICKET") {
                setIsTicket(true);
            }
        }
        
        if(fbo != null) {
            reset(fbo.IsoRequest);
            
            if(fbo.reporter != null) {
                setSelectedReporter(fbo.reporter);
            }

            if(fbo.customer != null) {
                setSelectedCustomer([fbo.customer]);
            }

            if(fbo.isoRequest.id == id) {
                if(loadingStarted) {
                    validateIsoRequestStatusChange(fbo);
                }
            }
        }
        
        clearErrors();
    }, [fbo]);

    const reloadAction = () => {
        setRefreshAction(!refreshAction);
    }

    const onChangeDocument = (isProduct) => {
        if(fboState) {
            validateIsoRequestStatusChange(fboState);
        }

        setRefreshAction(!refreshAction);
    }

    const getFormattedDate = (value) => {
        if(value) {
            return dateFormat(value, "mm/dd/yyyy");
        }
        return "";
    }

    const getFormattedDateTime = (value) => {
        if(value) {
            return dateFormat(value, "mm/dd/yyyy HH:MM");
        }
        return "";
    }

    const getDateWithoutTimezone = (value) => {
        if(value) {
            const tzoffset = value.getTimezoneOffset() * 60000;
            const withoutTimezone = new Date(value.valueOf() - tzoffset).toISOString().slice(0, -1);
            return withoutTimezone;
        }
        return "";
    }

    const getColorByGroup = (groupId) => {
        if (!groupId) return "#6c757d";

        let hash = 0;
        const str = groupId.toString();

        for (let i = 0; i < str.length; i++) {
            hash = str.charCodeAt(i) + ((hash << 5) - hash);
        }

        const GOLDEN_ANGLE = 137.508;
        const hue = (hash * GOLDEN_ANGLE) % 360;

        return `hsl(${hue}, 65%, 50%)`;
    };

    const getIntegratedCertificateList = (id, accreditationType) => {
        var arrCertificateList = [];

        if(fboState) {
            if(fboState.isoRequest.certificates) {
                fboState.isoRequest.certificates.forEach((certificate, i) => {
                    if(certificate.id !== id && certificate.certificate.accreditationType === accreditationType && certificate.manDay.auditKind === "Integrated Audit") {
                        arrCertificateList.push(certificate);
                    }
                });
            }
        }

        return arrCertificateList;
    }

    const getIntegratedAuditorList = (groupId) => {
        var arrItems = [];

        if(fboState) {
            if(fboState.isoRequest.certificates) {
                fboState.isoRequest.certificates.forEach((certificate, i) => {
                    if(certificate.id === groupId) {
                        certificate.auditors.forEach((auditor, i) => {
                            if(auditor.isDeleted === false) {
                                arrItems.push(auditor);
                            }
                        });
                    }
                });
            }
        }

        return arrItems;
    }

    const getIntegratedLocationList = (groupId) => {
        var arrItems = [];

        if(fboState) {
            if(fboState.isoRequest.certificates) {
                fboState.isoRequest.certificates.forEach((certificate, i) => {
                    if(certificate.id === groupId) {
                        certificate.locations.forEach((location, i) => {
                            if(location.isDeleted === false) {
                                arrItems.push(location);
                            }
                        });
                    }
                });
            }
        }

        return arrItems;
    }

    const hasLocations = (certificate) => {
        var integratedCount = 0;

        if(certificate.groupId !== certificate.id) {
            integratedCount = getIntegratedLocationList(certificate.groupId).length;
        }
        
        if(certificate && certificate.locations && certificate.locations.filter(x => x.isDeleted === false).length > 0) {
            return true;
        }
        else if(integratedCount > 0) {
            return true;
        }

        return false;
    }

    const hasLocationBothDates = (certificate) => {
        if(certificate.certificate.isRecertification || certificate.requestType !== "Initial Audit") {
            return false;
        }

        return true;
    }

    const onIsoRequestChange = (name, value, isBlur) => {
        var copy_fboState = createDeepClone(fboState);

        if(value && isBlur) {
            value = value.trim();
        }

        if(value) {
            copy_fboState.isoRequest[name] = value;
        }
        else if(value === false) {
            copy_fboState.isoRequest[name] = false;
        }
        else {
            copy_fboState.isoRequest[name] = null;
        }

        if(name === "crmName" || name === "crmCountry") {
            copy_fboState.isoRequest["customerId"] = null;
            copy_fboState.isoRequest["customerName"] = null;
            copy_fboState.isoRequest["customerAddress"] = null;
            copy_fboState.isoRequest["customerContactName"] = null;
            copy_fboState.isoRequest["customerContactEmail"] = null;
            copy_fboState.isoRequest["customerContactPhone"] = null;
            
            setSelectedCustomer([]);
        }

        if(name === "isHistoryData") {
            var isHistoryData = copy_fboState.isoRequest.isHistoryData;

            if(copy_fboState.isNew) {
                if(isHistoryData === "Yes") {
                    copy_fboState.canScheduling = false;
                    copy_fboState.canCompleted = true;
                }
                else {
                    copy_fboState.canScheduling = true;
                    copy_fboState.canCompleted = false;
                }
            }
        }

        setFBOState(copy_fboState);
        setIsDirty(true);
    }

    const onIsoRequestLocationAdd = () => {
        var copy_fboState = createDeepClone(fboState);
        var copy_location = createDeepClone(fboState.isoRequestLocation);
        
        copy_fboState.isoRequest.locations.push(copy_location);
        
        setFBOState(copy_fboState);
        setIsDirty(true);
    }

    const onIsoRequestLocationChange = (index, name, value, isBlur) => {
        var copy_fboState = createDeepClone(fboState);

        if(value && isBlur) {
            value = value.trim();
        }

        if(value) {
            copy_fboState.isoRequest.locations[index][name] = value;
        }
        else if(value === false) {
            copy_fboState.isoRequest.locations[index][name] = false;
        }
        else {
            copy_fboState.isoRequest.locations[index][name] = null;
        }

        copy_fboState.isoRequest.locations[index]["isModified"] = true;

        setFBOState(copy_fboState);
        setIsDirty(true);
    }

    const onCertificationAdminUserChange = (value, isBlur) => {
        var copy_fboState = createDeepClone(fboState);
        
        if(value && isBlur) {
            value = value.trim();
        }

        if(value == 0) {
            copy_fboState.isoRequest["certificationAdminUserId"] = null;
        }
        else {
            copy_fboState.isoRequest["certificationAdminUserId"] = value;
        }
        
        setFBOState(copy_fboState);
        setIsDirty(true);
    }

    const onSchedulingResponsibleUserChange = (certificateIndex, value, isBlur) => {
        var copy_fboState = createDeepClone(fboState);
        
        if(value && isBlur) {
            value = value.trim();
        }

        if(value == 0) {
            copy_fboState.isoRequest.certificates[certificateIndex]["schedulingResponsibleUserId"] = null;
        }
        else {
            copy_fboState.isoRequest.certificates[certificateIndex]["schedulingResponsibleUserId"] = value;
        }

        copy_fboState.isoRequest.certificates.forEach(certificate => {
            if(certificate["groupId"] == copy_fboState.isoRequest.certificates[certificateIndex]["groupId"]) {
                certificate["schedulingResponsibleUserId"] = copy_fboState.isoRequest.certificates[certificateIndex]["schedulingResponsibleUserId"]
                certificate["isModified"] = true;
            }
        });

        copy_fboState.isoRequest.certificates[certificateIndex]["isModified"] = true;
        
        setFBOState(copy_fboState);
        setIsDirty(true);
    }

    const onMdcIssuerUserChange = (certificateIndex, value, isBlur) => {
        var copy_fboState = createDeepClone(fboState);
        
        if(value && isBlur) {
            value = value.trim();
        }

        if(value == 0) {
            copy_fboState.isoRequest.certificates[certificateIndex]["mdcIssuerUserId"] = null;
        }
        else {
            copy_fboState.isoRequest.certificates[certificateIndex]["mdcIssuerUserId"] = value;
        }

        copy_fboState.isoRequest.certificates.forEach(certificate => {
            if(certificate["groupId"] == copy_fboState.isoRequest.certificates[certificateIndex]["groupId"]) {
                certificate["mdcIssuerUserId"] = copy_fboState.isoRequest.certificates[certificateIndex]["mdcIssuerUserId"]
                certificate["isModified"] = true;
            }
        });

        copy_fboState.isoRequest.certificates[certificateIndex]["isModified"] = true;
        
        setFBOState(copy_fboState);
        setIsDirty(true);
    }

    const onCaseLeaderUserChange = (certificateIndex, value, isBlur) => {
        var copy_fboState = createDeepClone(fboState);
        
        if(value && isBlur) {
            value = value.trim();
        }

        if(value == 0) {
            copy_fboState.isoRequest.certificates[certificateIndex]["caseLeaderUserId"] = null;
        }
        else {
            copy_fboState.isoRequest.certificates[certificateIndex]["caseLeaderUserId"] = value;
        }

        copy_fboState.isoRequest.certificates.forEach(certificate => {
            if(certificate["groupId"] == copy_fboState.isoRequest.certificates[certificateIndex]["groupId"]) {
                certificate["caseLeaderUserId"] = copy_fboState.isoRequest.certificates[certificateIndex]["caseLeaderUserId"]
                certificate["isModified"] = true;
            }
        });

        copy_fboState.isoRequest.certificates[certificateIndex]["isModified"] = true;
        
        setFBOState(copy_fboState);
        setIsDirty(true);
    }

    const onAuditDocumentReviewerUserChange = (value, isBlur) => {
        var copy_fboState = createDeepClone(fboState);
        
        if(value && isBlur) {
            value = value.trim();
        }

        if(value == 0) {
            copy_fboState.isoRequest["auditDocumentReviewerUserId"] = null;
        }
        else {
            copy_fboState.isoRequest["auditDocumentReviewerUserId"] = value;
        }
        
        setFBOState(copy_fboState);
        setIsDirty(true);
    }

    const onTechnicalReviewerUserChange = (value, isBlur) => {
        var copy_fboState = createDeepClone(fboState);
        
        if(value && isBlur) {
            value = value.trim();
        }

        if(value == 0) {
            copy_fboState.isoRequest["technicalReviewerUserId"] = null;
        }
        else {
            copy_fboState.isoRequest["technicalReviewerUserId"] = value;
        }
        
        setFBOState(copy_fboState);
        setIsDirty(true);
    }

    const onDecisionMakerUserChange = (value, isBlur) => {
        var copy_fboState = createDeepClone(fboState);
        
        if(value && isBlur) {
            value = value.trim();
        }

        if(value == 0) {
            copy_fboState.isoRequest["decisionMakerUserId"] = null;
        }
        else {
            copy_fboState.isoRequest["decisionMakerUserId"] = value;
        }
        
        setFBOState(copy_fboState);
        setIsDirty(true);
    }

    const onReporterChange = (items) => {
        setSelectedReporter(items);
        
        if(items.length > 0) {
            var ids = [];
            
            items.forEach(element => {
                ids.push(element.id);
            });

            onIsoRequestChange("reporterUserId", ids.toString(), false);
        }
        else {
            onIsoRequestChange("reporterUserId", null, false);
        }
    }

    const onCustomerChange = (item) => {
        var copy_fboState = createDeepClone(fboState);
        setSelectedCustomer(item);
        
        if(item.length > 0) {
            copy_fboState.isoRequest["customerId"] = item[0].id.toString();
            copy_fboState.isoRequest["customerName"] = item[0].organizationName;
            copy_fboState.isoRequest["customerAddress"] = item[0].fullAddress;
            copy_fboState.isoRequest["customerContactName"] = item[0].fullName || "";
            copy_fboState.isoRequest["customerContactEmail"] = item[0].email || "";
            copy_fboState.isoRequest["customerContactPhone"] = item[0].telephoneNumber || "";
        }
        else {
            copy_fboState.isoRequest["customerId"] = null;
            copy_fboState.isoRequest["customerName"] = null;
            copy_fboState.isoRequest["customerAddress"] = null;
            copy_fboState.isoRequest["customerContactName"] = null;
            copy_fboState.isoRequest["customerContactEmail"] = null;
            copy_fboState.isoRequest["customerContactPhone"] = null;
        }

        setFBOState(copy_fboState);
        setIsDirty(true);
    }

    const onCertificateAdd = () => {
        setNewRequestType("");
        setNewRequestTypeOther("");
        setNewCertificateNumber("");
        setNewAccreditationType("");
        setNewManDayStandardId("");
        setShowAddCertificateModal(true);
    }

    const onAddCertificateClick = async () => {
        var valid = true;
        if(valid) {
            setLoadingLocal(true);
            var data = await isoRequestActions.addCertificateToIsoRequest(fboState.isoRequest.id, newRequestType, newRequestTypeOther, newCertificateNumber, newAccreditationType, newManDayStandardId);
            setLoadingLocal(false);

            if(data.success) {
                dispatch(commonActions.setSuccessMessage(data.successMessage));
                dispatch(isoRequestActions.loadIsoRequest(fboState.isoRequest.id, navigate));
                setShowAddCertificateModal(false);
            }
            else{
                dispatch(commonActions.setErrorMessage(data.errorMessage));
            }

            reloadAction();
        }
    }

    const hideAddCertificateModal = () => {
        setShowAddCertificateModal(false);
    }

    const onRemoveCertificate = async (isoRequestCertificateId) => {
        setRemoveCertificateId(isoRequestCertificateId);
        setShowRemoveCertificateModal(true);
    }

    const onSaveRemoveCertificate = async () => {
        setShowRemoveCertificateModal(false);

        setLoadingLocal(true);
        var data = await isoRequestActions.removeCertificate(removeCertificateId);
        setLoadingLocal(false);

        if(data.success) {
            dispatch(commonActions.setSuccessMessage(data.successMessage));
            dispatch(isoRequestActions.loadIsoRequest(fboState.isoRequest.id, navigate));
        }
        else{
            dispatch(commonActions.setErrorMessage(data.errorMessage));
        }

        setCurrentMessage("");
        reloadAction();
    }

    const onRequestCertificateChange = (certificateIndex, name, value, isBlur) => {
        var copy_fboState = createDeepClone(fboState);
        
        if(value && isBlur) {
            value = value.trim();
        }

        if(value) {
            copy_fboState.isoRequest.certificates[certificateIndex][name] = value;
        }
        else if(value === false) {
            copy_fboState.isoRequest.certificates[certificateIndex][name] = false;
        }
        else {
            copy_fboState.isoRequest.certificates[certificateIndex][name] = null;
        }

        copy_fboState.isoRequest.certificates[certificateIndex]["isModified"] = true;

        setFBOState(copy_fboState);
        setIsDirty(true);
    }
    
    const onCertificateChange = (certificateIndex, name, value, isBlur) => {
        var copy_fboState = createDeepClone(fboState);
        
        if(value && isBlur) {
            value = value.trim();
        }

        if(value) {
            copy_fboState.isoRequest.certificates[certificateIndex].certificate[name] = value;
        }
        else if(value === false) {
            copy_fboState.isoRequest.certificates[certificateIndex].certificate[name] = false;
        }
        else {
            copy_fboState.isoRequest.certificates[certificateIndex].certificate[name] = null;
        }

        if(name === "certificateIssueDate") {
            if(value) {
                if(copy_fboState.isoRequest.certificates[certificateIndex].certificate["accreditationType"] === "Unaccredited") {
                    copy_fboState.isoRequest.certificates[certificateIndex].certificate["certificateIssueDate"] = getDateWithoutTimezone(value);
                    copy_fboState.isoRequest.certificates[certificateIndex].certificate["surveillance1Date"] = null;
                    copy_fboState.isoRequest.certificates[certificateIndex].certificate["surveillance2Date"] = null;
                    copy_fboState.isoRequest.certificates[certificateIndex].certificate["certificateExpiryDate"] = getDateWithoutTimezone(new Date(moment(value).add(1,'y').subtract(1, 'days')));
                }
                else {
                    copy_fboState.isoRequest.certificates[certificateIndex].certificate["certificateIssueDate"] = getDateWithoutTimezone(value);
                    copy_fboState.isoRequest.certificates[certificateIndex].certificate["surveillance1Date"] = getDateWithoutTimezone(new Date(moment(value).add(1,'y').subtract(1, 'days')));
                    copy_fboState.isoRequest.certificates[certificateIndex].certificate["surveillance2Date"] = getDateWithoutTimezone(new Date(moment(value).add(2,'y').subtract(1, 'days')));
                    copy_fboState.isoRequest.certificates[certificateIndex].certificate["certificateExpiryDate"] = getDateWithoutTimezone(new Date(moment(value).add(3,'y').subtract(1, 'days')));
                }
            }
            else {
                copy_fboState.isoRequest.certificates[certificateIndex].certificate["surveillance1Date"] = null;
                copy_fboState.isoRequest.certificates[certificateIndex].certificate["surveillance2Date"] = null;
                copy_fboState.isoRequest.certificates[certificateIndex].certificate["certificateExpiryDate"] = null;
            }

            copy_fboState.isoRequest.certificates[certificateIndex].certificate["showCertificateLabel"] = false;
        }

        copy_fboState.isoRequest.certificates[certificateIndex].certificate["isModified"] = true;

        setFBOState(copy_fboState);
        setIsDirty(true);
    }

    const onCertificateLocationAdd = (certificateIndex) => {
        var copy_fboState = createDeepClone(fboState);
        var copy_location = createDeepClone(fboState.isoCertificateLocation);
        
        copy_fboState.isoRequest.certificates[certificateIndex].certificate.locations.push(copy_location);
        
        setFBOState(copy_fboState);
        setIsDirty(true);
    }

    const onCertificateLocationChange = (certificateIndex, index, name, value, isBlur) => {
        var copy_fboState = createDeepClone(fboState);

        if(value && isBlur) {
            value = value.trim();
        }

        if(value) {
            copy_fboState.isoRequest.certificates[certificateIndex].certificate.locations[index][name] = value;
        }
        else if(value === false) {
            copy_fboState.isoRequest.certificates[certificateIndex].certificate.locations[index][name] = false;
        }
        else {
            copy_fboState.isoRequest.certificates[certificateIndex].certificate.locations[index][name] = null;
        }

        copy_fboState.isoRequest.certificates[certificateIndex].certificate.locations[index]["isModified"] = true;

        setFBOState(copy_fboState);
        setIsDirty(true);
    }

    const onManDayChange = (certificateIndex, name, value, isBlur) => {
        var copy_fboState = createDeepClone(fboState);

        if(value && isBlur) {
            value = value.trim();
        }

        if(value) {
            if(name === "complexityValue" || name === "auditHour" || name === "factorPercentage") {
                value = value.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1');
            }
            else if(name === "soaDate") {
                value = getDateWithoutTimezone(value);
            }

            copy_fboState.isoRequest.certificates[certificateIndex].manDay[name] = value;
        }
        else if(value === false) {
            copy_fboState.isoRequest.certificates[certificateIndex].manDay[name] = false;
        }
        else {
            copy_fboState.isoRequest.certificates[certificateIndex].manDay[name] = null;
        }

        if(name === "manDayStandardId") {
            copy_fboState.isoRequest.certificates[certificateIndex].manDay["personCount"] = null;
            copy_fboState.isoRequest.certificates[certificateIndex].manDay["complexity"] = null;
            copy_fboState.isoRequest.certificates[certificateIndex].manDay["complexityValue"] = null;

            copy_fboState.isoRequest.certificates[certificateIndex].certificate[name] = value;
            copy_fboState.isoRequest.certificates[certificateIndex].certificate["isModified"] = true;
        }
        else if(name === "personCount") {
            copy_fboState.isoRequest.certificates[certificateIndex].manDay["complexity"] = null;
            copy_fboState.isoRequest.certificates[certificateIndex].manDay["complexityValue"] = null;
        }
        else if(name === "complexity") {
            var complexityValue = null;

            var config = fboState.manDayStandardConfigurationList.find(item => item.accreditationType == copy_fboState.isoRequest.certificates[certificateIndex].manDay["accreditationType"] && item.personnelDisplay == copy_fboState.isoRequest.certificates[certificateIndex].manDay["personCount"]);
            if (config != null) {
                if (value === 'Low') {
                    complexityValue = config.complexityLow;
                } else if (value === 'Medium') {
                    complexityValue = config.complexityMedium;
                } else if (value === 'High') {
                    complexityValue = config.complexityHigh;
                }
            }

            copy_fboState.isoRequest.certificates[certificateIndex].manDay["complexityValue"] = complexityValue;
        }

        copy_fboState.isoRequest.certificates[certificateIndex].manDay["isModified"] = true;

        if(name != 'factorComplexityValue' && name != 'factorAuditHour') {
            copy_fboState = calculateTotalManDay(copy_fboState);
            copy_fboState = calculateManDayFactor(certificateIndex, copy_fboState);
        }

        setFBOState(copy_fboState);
        setIsDirty(true);
    }
    
    const calculateManDayFactor = (certificateIndex, copy_fboState,) => {
        var complexityValue = parseFloat(copy_fboState.isoRequest.certificates[certificateIndex].manDay["complexityValue"] || 0);
        var auditHour = parseFloat(copy_fboState.isoRequest.certificates[certificateIndex].manDay["auditHour"] || 0);
        var factorValue = copy_fboState.isoRequest.certificates[certificateIndex].manDay["factorValue"] || "";
        var factorPercentage = parseFloat(copy_fboState.isoRequest.certificates[certificateIndex].manDay["factorPercentage"] || 0);
        var factorComplexityValue = complexityValue;
        var factorAuditHour = auditHour;

        if(complexityValue > 0 && factorPercentage > 0) {
            if(factorValue === "Increase") {
                factorComplexityValue = complexityValue + (complexityValue * factorPercentage / 100);
                factorAuditHour = auditHour + (auditHour * factorPercentage / 100);
            }
            else if(factorValue === "Decrease") {
                factorComplexityValue = complexityValue - (complexityValue * factorPercentage / 100);
                factorAuditHour = auditHour - (auditHour * factorPercentage / 100);
            }
        }

        copy_fboState.isoRequest.certificates[certificateIndex].manDay["factorComplexityValue"] = Math.floor(factorComplexityValue);
        copy_fboState.isoRequest.certificates[certificateIndex].manDay["factorAuditHour"] = Math.floor(factorAuditHour);
        
        return copy_fboState;
    }

    const calculateTotalManDay = (copy_fboState) => {
        // var totalComplexityValue = 0;
        // var totalAuditHour = 0;

        // copy_fboState.isoRequest.manDays.forEach(element => {
        //     totalComplexityValue += parseFloat(element.complexityValue || 0);
        //     totalAuditHour += parseFloat(element.auditHour || 0);
        // });

        // copy_fboState.isoRequest["complexityValue"] = totalComplexityValue;
        // copy_fboState.isoRequest["auditHour"] = totalAuditHour;
        
        return copy_fboState;
    }

    const onAuditorAdd = (certificateIndex) => {
        var copy_fboState = createDeepClone(fboState);
        var copy_auditor = createDeepClone(fboState.auditor);
        
        copy_fboState.isoRequest.certificates[certificateIndex].auditors.push(copy_auditor);
        
        setFBOState(copy_fboState);
        setIsDirty(true);
    }

    const onAuditorChange = (certificateIndex, index, name, value, isBlur) => {
        var copy_fboState = createDeepClone(fboState);

        if(value && isBlur) {
            value = value.trim();
        }

        if(value) {
            if(name === "complexityValue" || name === "auditHour") {
                value = value.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1');
            }

            if(name === "auditorType" && value === "Lead Auditor") {
                var haveAnotherLeadAuditor = false;
                copy_fboState.isoRequest.certificates[certificateIndex].auditors.forEach((auditor, i) => {
                    if(auditor.isDeleted === false && i != index && auditor.auditorType === "Lead Auditor") {
                        haveAnotherLeadAuditor = true;
                    }
                });
            }

            if(haveAnotherLeadAuditor) {
                dispatch(commonActions.setErrorMessage("Only one Lead Auditor can be assigned for an Audit Team"));
                return;
            }

            copy_fboState.isoRequest.certificates[certificateIndex].auditors[index][name] = value;
        }
        else if(value === false) {
            copy_fboState.isoRequest.certificates[certificateIndex].auditors[index][name] = false;
        }
        else {
            copy_fboState.isoRequest.certificates[certificateIndex].auditors[index][name] = null;
        }

        if(name === "auditorType") {
            copy_fboState.isoRequest.certificates[certificateIndex].auditors[index]["auditorId"] = null;
            copy_fboState.isoRequest.certificates[certificateIndex].auditors[index]["auditorList"] = [];
        }

        copy_fboState.isoRequest.certificates[certificateIndex].auditors[index]["isModified"] = true;

        setFBOState(copy_fboState);
        setIsDirty(true);
    }

    const onAuditorUserChange = (certificateIndex, index, item) => {
        var copy_fboState = createDeepClone(fboState);
        
        if(item.length > 0) {
            copy_fboState.isoRequest.certificates[certificateIndex].auditors[index]["auditorId"] = item[0].id;
            copy_fboState.isoRequest.certificates[certificateIndex].auditors[index]["auditorList"] = item;
        }
        else {
            copy_fboState.isoRequest.certificates[certificateIndex].auditors[index]["auditorId"] = null;
            copy_fboState.isoRequest.certificates[certificateIndex].auditors[index]["auditorList"] = item;
        }

        copy_fboState.isoRequest.certificates[certificateIndex].auditors[index]["isModified"] = true;

        setFBOState(copy_fboState);
        setIsDirty(true);
    }   

    const onLocationAdd = (certificateIndex) => {
        var copy_fboState = createDeepClone(fboState);
        var copy_location = createDeepClone(fboState.location);
        
        copy_fboState.isoRequest.certificates[certificateIndex].locations.push(copy_location);
        
        setFBOState(copy_fboState);
        setIsDirty(true);
    }

    const onLocationChange = (certificateIndex, index, name, value, isBlur) => {
        var copy_fboState = createDeepClone(fboState);

        if(value && isBlur) {
            value = value.trim();
        }

        if(value) {
            if(name === "auditDate") {
                copy_fboState.isoRequest.certificates[certificateIndex].locations[index][name] = getDateWithoutTimezone(value);
            }
            else {
                copy_fboState.isoRequest.certificates[certificateIndex].locations[index][name] = value;
            }
        }
        else if(value === false) {
            copy_fboState.isoRequest.certificates[certificateIndex].locations[index][name] = false;
        }
        else {
            copy_fboState.isoRequest.certificates[certificateIndex].locations[index][name] = null;
        }

        copy_fboState.isoRequest.certificates[certificateIndex].locations[index]["isModified"] = true;

        setFBOState(copy_fboState);
        setIsDirty(true);
    }

    const onLocationDateAdd = (certificateIndex, locationIndex) => {
        var copy_fboState = createDeepClone(fboState);
        var copy_location_date = {
            isoLocationId: 0,
            auditDate: null,
            isDeleted: false,
            isModified: true
        };
        
        copy_fboState.isoRequest.certificates[certificateIndex].locations[locationIndex].auditDateList.push(copy_location_date);
        
        setFBOState(copy_fboState);
        setIsDirty(true);
    }
    
    const onLocationDateChange = (certificateIndex, index, dateIndex, name, value, isBlur) => {
        var copy_fboState = createDeepClone(fboState);

        if(value && isBlur) {
            value = value.trim();
        }

        if(value) {
            if(name === "auditDate") {
                copy_fboState.isoRequest.certificates[certificateIndex].locations[index].auditDateList[dateIndex][name] = getDateWithoutTimezone(value);
            }
            else {
                copy_fboState.isoRequest.certificates[certificateIndex].locations[index].auditDateList[dateIndex][name] = value;
            }
        }
        else if(value === false) {
            copy_fboState.isoRequest.certificates[certificateIndex].locations[index].auditDateList[dateIndex][name] = false;
        }
        else {
            copy_fboState.isoRequest.certificates[certificateIndex].locations[index].auditDateList[dateIndex][name] = null;
        }

        copy_fboState.isoRequest.certificates[certificateIndex].locations[index].auditDateList[dateIndex]["isModified"] = true;

        setFBOState(copy_fboState);
        setIsDirty(true);
    }

    const onSaveIsoRequest = async() => {
        const valid = await trigger();
        if(valid) {
            dispatch(isoRequestActions.saveIsoRequest(fboState, selectedStatus, currentMessage, false, navigate));

            if(selectedStatus && selectedStatus.length > 0) {
                setAutoStatusChangeShown(false);
            }
        }

        onCloseModalClick();
    }

    const onCancelIsoRequest = () => {
        setFBOState(fbo);

        if(fbo.reporter != null) {
            setSelectedReporter(fbo.reporter);
        }
        else {
            setSelectedReporter([]);
        }

        if(fbo.customer != null) {
            setSelectedCustomer([fbo.customer]);
        }
        else {
            setSelectedCustomer([]);
        }

        setIsDirty(false);
        clearErrors();
    }

    const validateIsoRequestStatusChange = async (fbo) => {
        if(autoStatusChangeShown === false && fbo.nextStatus) {
            var validationResult = await isoRequestActions.validateIsoRequestStatusChange(fbo, fbo.nextStatus);
            if(validationResult && validationResult.success === true) {
                setAutoStatusNextStatus(fbo.nextStatus);
                setSelectedStatus(fbo.nextStatus);
                setCurrentMessage("");

                setShowAutoStatusChangeModal(true);
                setAutoStatusChangeShown(true);
            }
        }
    }
    
    const onSubmitIsoRequetClick = () => {
        setSelectedStatus("New");
        setCurrentMessage("");
        setShowSubmitModal(true);
    }

    const onSalesActionIsoRequetClick = () => {
        setSelectedStatus("Sales Action");
        setCurrentMessage("");
        setShowSalesActionModal(true);
    }

    const onNewIsoRequetClick = () => {
        setSelectedStatus("New");
        setCurrentMessage("");
        setShowNewModal(true);
    }

    const onCalculateManDaysIsoRequetClick = () => {
        setSelectedStatus("Calculate Man Days");
        setCurrentMessage("");
        setShowCalculateManDaysModal(true);
    }

    const onSchedulingIsoRequetClick = () => {
        setSelectedStatus("Scheduling");
        setCurrentMessage("");
        setShowSchedulingModal(true);
    }

    const onAuditInProgressIsoRequetClick = () => {
        setSelectedStatus("Audit In Progress");
        setCurrentMessage("");
        setShowAuditInProgressModal(true);
    }

    const onDocumentReviewIsoRequetClick = () => {
        setSelectedStatus("Document Review");
        setCurrentMessage("");
        setShowDocumentReviewModal(true);
    }

    const onTechnicalReviewIsoRequetClick = () => {
        setSelectedStatus("Technical Review");
        setCurrentMessage("");
        setShowTechnicalReviewModal(true);
    }

    const onDecisionMakingIsoRequetClick = () => {
        setSelectedStatus("Decision Making");
        setCurrentMessage("");
        setShowDecisionMakingModal(true);
    }

    const onCertificateGenerationIsoRequetClick = () => {
        setSelectedStatus("Certificate Generation");
        setCurrentMessage("");
        setShowCertificateGenerationModal(true);
    }

    const onCompletedIsoRequetClick = () => {
        setSelectedStatus("Completed");
        setCurrentMessage("");
        setShowCompletedModal(true);
    }

    const onClosedIsoRequetClick = () => {
        setSelectedStatus("Closed");
        setCurrentMessage("");
        setShowClosedModal(true);
    }

    const onAbortedIsoRequetClick = () => {
        setSelectedStatus("Aborted");
        setCurrentMessage("");
        setShowAbortedModal(true);
    }

    const onResetToDraftIsoRequetClick = () => {
        setSelectedStatus("Draft");
        setCurrentMessage("");
        setShowResetToDraftModal(true);
    }

    const onAssignMeTicket = async () => {
        dispatch(isoRequestActions.assignMeIsoRequest(fboState.isoRequest.id, user.id, true, navigate));
        onCloseModalClick();
    }

    const onAssignMeTicketClick = () => {
        setShowAssignMeModal(true);
    }

    const onProceedWithoutPayment = async () => {
        setShowProceedWithoutPaymentModal(true);
    }

    const onSaveProceedWithoutPayment = async () => {
        setShowProceedWithoutPaymentModal(false);

        setLoadingLocal(true);
        var data = await isoRequestActions.markProceedWithoutPayment(fboState.isoRequest.id, currentMessage);
        setLoadingLocal(false);

        if(data.success) {
            dispatch(commonActions.setSuccessMessage(data.successMessage));
            dispatch(isoRequestActions.loadIsoRequest(fboState.isoRequest.id, navigate));
        }
        else{
            dispatch(commonActions.setErrorMessage(data.errorMessage));
        }

        setCurrentMessage("");
        reloadAction();
    }

    const onNotifyProceedWithoutPayment = async () => {
        setShowNotifyProceedWithoutPaymentModal(true);
    }

    const onSaveNotifyProceedWithoutPayment = async () => {
        setShowNotifyProceedWithoutPaymentModal(false);

        setLoadingLocal(true);
        var data = await isoRequestActions.notifyMarkProceedWithoutPayment(fboState.isoRequest.id, currentMessage);
        setLoadingLocal(false);

        if(data.success) {
            dispatch(commonActions.setSuccessMessage(data.successMessage));
            dispatch(isoRequestActions.loadIsoRequest(fboState.isoRequest.id, navigate));
        }
        else{
            dispatch(commonActions.setErrorMessage(data.errorMessage));
        }

        setCurrentMessage("");
        reloadAction();
    }

    const onGenerateCertificate = async (certificateId) => {
        setGenerateCertificateErrorMessages([]);

        setLoadingLocal(true);
        var errors = await isoRequestActions.validateGenerateCertificate(fboState.isoRequest.id, certificateId);
        setLoadingLocal(false);

        if(errors.length > 0) {
            setGenerateCertificateErrorMessages(errors);
            setGenerateCertificateId(certificateId);
            setShowGenerateCertificateModal(true);
        }
        else{
            setGenerateCertificateId(certificateId);
            setShowGenerateCertificateModal(true);
        }
    }

    const onSaveGenerateCertificate = async () => {
        setShowGenerateCertificateModal(false);

        setLoadingLocal(true);
        var data = await isoRequestActions.generateCertificate(fboState.isoRequest.id, generateCertificateId, currentMessage);
        setLoadingLocal(false);

        if(data.success) {
            dispatch(commonActions.setSuccessMessage(data.successMessage));
            dispatch(isoRequestActions.loadIsoRequest(fboState.isoRequest.id, navigate));
        }
        else{
            dispatch(commonActions.setErrorMessage(data.errorMessage));
        }

        setCurrentMessage("");
        reloadAction();
    }

    const onGenerateCertificateDownload = async (certificateId) => {
        setGenerateCertificateErrorMessages([]);

        setLoadingLocal(true);
        var errors = await isoRequestActions.validateGenerateCertificate(fboState.isoRequest.id, certificateId);
        setLoadingLocal(false);

        if(errors.length > 0) {
            setGenerateCertificateErrorMessages(errors);
            setGenerateCertificateId(certificateId);
            setShowGenerateCertificateDownloadModal(true);
        }
        else{
            setGenerateCertificateId(certificateId);
            setShowGenerateCertificateDownloadModal(true);
        }
    }

    const onSaveGenerateCertificateDownload = async () => {
        setShowGenerateCertificateDownloadModal(false);
        dispatch(isoRequestActions.generateCertificateDownload(fboState.isoRequest.id, generateCertificateId));
    }

    const onGenerateMdc = async (groupId) => {
        setGenerateMdcId(groupId);
        setShowGenerateMdcModal(true);
    }

    const onSaveGenerateMdc = async () => {
        setShowGenerateMdcModal(false);

        setLoadingLocal(true);
        var data = await isoRequestActions.generateMdc(fboState.isoRequest.id, generateMdcId);
        setLoadingLocal(false);

        if(data.success) {
            dispatch(commonActions.setSuccessMessage(data.successMessage));
        }
        else{
            dispatch(commonActions.setErrorMessage(data.errorMessage));
        }

        setCurrentMessage("");
        reloadAction();
    }

    const onGenerateMdcDownload = (groupId) => {
        setGenerateMdcId(groupId);
        setShowGenerateMdcDownloadModal(true);
    }

    const onSaveGenerateMdcDownload = () => {
        setShowGenerateMdcDownloadModal(false);
        dispatch(isoRequestActions.generateMdcDownload(fboState.isoRequest.id, generateMdcId));
    }

    const onViewInvoice = async (crmInvoiceId) => {
        dispatch(isoRequestActions.viewInvoice(fboState.isoRequest.id, crmInvoiceId, navigate));
        setShowInvoiceViewModal(true);
    }

    const hideInvoiceViewModal = async () => {
        setShowInvoiceViewModal(false);
    }

    const onRemoveInvoice = async (paymentId) => {
        setRemoveInvoiceId(paymentId);
        setShowRemoveInvoiceModal(true);
    }

    const onSaveRemoveInvoice = async () => {
        setShowRemoveInvoiceModal(false);

        setLoadingLocal(true);
        var data = await isoRequestActions.removeInvoice(fboState.isoRequest.id, removeInvoiceId);
        setLoadingLocal(false);

        if(data.success) {
            dispatch(commonActions.setSuccessMessage(data.successMessage));
            dispatch(isoRequestActions.loadIsoRequest(fboState.isoRequest.id, navigate));
        }
        else{
            dispatch(commonActions.setErrorMessage(data.errorMessage));
        }

        setCurrentMessage("");
        reloadAction();
    }

    const onCloseModalClick = () => {
        setSelectedStatus("");
        setCurrentMessage("");

        setShowAssignMeModal(false);
        setShowSubmitModal(false);
        setShowSalesActionModal(false);
        setShowNewModal(false);
        setShowCalculateManDaysModal(false);
        setShowSchedulingModal(false);
        setShowAuditInProgressModal(false);
        setShowDocumentReviewModal(false);
        setShowTechnicalReviewModal(false);
        setShowDecisionMakingModal(false);
        setShowCertificateGenerationModal(false);
        setShowCompletedModal(false);
        setShowClosedModal(false);
        setShowAbortedModal(false);
        setShowResetToDraftModal(false);
        setShowProceedWithoutPaymentModal(false);
        setShowNotifyProceedWithoutPaymentModal(false);
        setShowGenerateCertificateModal(false);
        setShowGenerateCertificateDownloadModal(false);
        setShowGenerateMdcModal(false);
        setShowGenerateMdcDownloadModal(false);
        setShowInvoiceViewModal(false);
        setShowRemoveInvoiceModal(false);
        setShowAddCertificateModal(false);
        setShowRemoveCertificateModal(false);
        setShowAutoStatusChangeModal(false);
    }    

    const AuditorRenderer = (results, menuProps, props) => (
        <Menu id="menuAuditorLookup" style={{minWidth:600}}>
            <div className="container">
                <div className="row font-weight-bold border-bottom">
                    <div className="col">Auditor Name</div>
                    <div className="col">Email</div>
                    <div className="col">Employee ID</div>
                </div>
            </div>
            {results.length == 0 && <div style={{padding:5}}>No Macthes Found...</div>}
            {results.map((result, idx) => (
                <MenuItem
                    key={idx}
                    option={result}
                    position={idx}>
                    <div className="row border-bottom">
                        <div className="col" style={{wordBreak: "break-all", whiteSpace: "normal"}}>
                            <Highlighter search={props.text}>
                                {result.fullName || ""}
                            </Highlighter>
                        </div>
                        <div className="col" style={{wordBreak: "break-all", whiteSpace: "normal"}}>
                            <Highlighter search={props.text}>
                                {result.email || ""}
                            </Highlighter>
                        </div>
                        <div className="col" style={{wordBreak: "break-all", whiteSpace: "normal"}}>
                            <Highlighter search={props.text}>
                                {result.employeeId || ""}
                            </Highlighter>
                        </div>
                    </div>
                </MenuItem>
            ))}
        </Menu>
    )

    return(
        <Fragment>
            <div className="page-content">
                <Container fluid>
                    <BreadCrumb title={`Edit ISO Ticket ${isContainer ? "Container" : ""}`} />
                    <Row>
                        <Col lg={9}>
                            <CardLoader loading={loading || loadingLocal} />

                            <Card className="mb-0">
                                <CardHeader className="border-0 d-flex align-items-center">
                                    <h5 className="card-title mb-0 flex-grow-1">
                                        ISO Ticket {isContainer ? "Container" : ""}
                                        {isChild && 
                                        <span style={{fontSize:"70%"}} className="ms-1">
                                            <Link to={`/iso-request-edit/${fboState && fboState.isoRequest.parentId}`}>
                                                (view container)
                                            </Link>
                                        </span>
                                        }
                                    </h5>
                                    <div className="flex-shrink-1 ms-3">
                                        <div className="d-flex flex-wrap gap-2">
                                            {fboState && (fboState.canSave || fboState.canSaveLimited) &&
                                            <button className="btn btn-primary btn-label"
                                                disabled={loading || !isDirty}
                                                onClick={onSaveIsoRequest}
                                            >
                                                <i className="ri-save-line label-icon align-middle"></i> Save ISO Ticket {isContainer ? "Container" : ""}
                                            </button>
                                            }
                                            {fboState && (fboState.canSave || fboState.canSaveLimited) &&
                                            <button className="btn btn-danger btn-label"
                                                disabled={loading || !isDirty}
                                                onClick={onCancelIsoRequest}
                                            >
                                                <i className="ri-close-line label-icon align-middle"></i> Cancel
                                            </button>
                                            }
                                            {fboState && fboState.canSubmit &&
                                            <button className="btn btn-secondary btn-label"
                                                disabled={loading}
                                                onClick={() => onSubmitIsoRequetClick()}
                                            >
                                                <i className="ri-check-double-line label-icon align-bottom"></i> Submit
                                            </button>
                                            }
                                            {fboState && fboState.canSalesAction &&
                                            <button className="btn btn-secondary btn-label"
                                                disabled={loading}
                                                onClick={() => onSalesActionIsoRequetClick()}
                                            >
                                                <i className="ri-check-double-line label-icon align-bottom"></i> Sales Action
                                            </button>
                                            }
                                            {fboState && fboState.canNew &&
                                            <button className="btn btn-secondary btn-label"
                                                disabled={loading}
                                                onClick={() => onNewIsoRequetClick()}
                                            >
                                                <i className="ri-check-double-line label-icon align-bottom"></i> Send Back to Certificate Admin
                                            </button>
                                            }
                                            {fboState && fboState.canScheduling &&
                                            <button className="btn btn-secondary btn-label"
                                                disabled={loading}
                                                onClick={() => onSchedulingIsoRequetClick()}
                                            >
                                                <i className="ri-check-double-line label-icon align-bottom"></i> {fboState && fboState.isNew ? "Send to Scheduling" : "Send Back to Scheduling"}
                                            </button>
                                            }
                                            {fboState && fboState.canCalculateManDays &&
                                            <button className="btn btn-secondary btn-label"
                                                disabled={loading}
                                                onClick={() => onCalculateManDaysIsoRequetClick()}
                                            >
                                                <i className="ri-check-double-line label-icon align-bottom"></i> {fboState && fboState.isScheduling ? "Calculate Man Days" : "Send Back To Calculate Man Days"}
                                            </button>
                                            }
                                            {fboState && fboState.canAuditInProgress &&
                                            <button className="btn btn-secondary btn-label"
                                                disabled={loading}
                                                onClick={() => onAuditInProgressIsoRequetClick()}
                                            >
                                                <i className="ri-check-double-line label-icon align-bottom"></i> {fboState && fboState.isCalculateManDays ? "Send to Audit" : "Send Back To Audit"}
                                            </button>
                                            }
                                            {fboState && fboState.canDocumentReview &&
                                            <button className="btn btn-secondary btn-label"
                                                disabled={loading}
                                                onClick={() => onDocumentReviewIsoRequetClick()}
                                            >
                                                <i className="ri-check-double-line label-icon align-bottom"></i> {fboState && fboState.isAuditInProgress ? "Document Review" : "Send Back To Document Review"}
                                            </button>
                                            }
                                            {fboState && fboState.canTechnicalReview &&
                                            <button className="btn btn-secondary btn-label"
                                                disabled={loading}
                                                onClick={() => onTechnicalReviewIsoRequetClick()}
                                            >
                                                <i className="ri-check-double-line label-icon align-bottom"></i> {fboState && fboState.isDocumentReview ? "Technical Review" : "Send Back To Technical Review"}
                                            </button>
                                            }
                                            {fboState && fboState.canDecisionMaking &&
                                            <button className="btn btn-secondary btn-label"
                                                disabled={loading}
                                                onClick={() => onDecisionMakingIsoRequetClick()}
                                            >
                                                <i className="ri-check-double-line label-icon align-bottom"></i> {fboState && fboState.isTechnicalReview ? "Decision Making" : "Send Back To Decision Making"}
                                            </button>
                                            }
                                            {fboState && fboState.canCertificateGeneration &&
                                            <button className="btn btn-secondary btn-label"
                                                disabled={loading}
                                                onClick={() => onCertificateGenerationIsoRequetClick()}
                                            >
                                                <i className="ri-check-double-line label-icon align-bottom"></i> {fboState && fboState.isDecisionMaking ? "Certificate Generation" : "Send Back To Certificate Generation"}
                                            </button>
                                            }
                                            {fboState && fboState.canCompleted &&
                                            <button className="btn btn-secondary btn-label"
                                                disabled={loading}
                                                onClick={() => onCompletedIsoRequetClick()}
                                            >
                                                <i className="ri-check-double-line label-icon align-bottom"></i> {fboState && fboState.isCertificateGeneration ? "Complete" : "Send Back To Complete"}
                                            </button>
                                            }
                                            {fboState && fboState.canClosed &&
                                            <button className="btn btn-secondary btn-label"
                                                disabled={loading}
                                                onClick={() => onClosedIsoRequetClick()}
                                            >
                                                <i className="ri-check-double-line label-icon align-bottom"></i> Close
                                            </button>
                                            }
                                            {fboState && fboState.canAborted &&
                                            <button className="btn btn-secondary btn-label"
                                                disabled={loading}
                                                onClick={() => onAbortedIsoRequetClick()}
                                            >
                                                <i className="ri-check-double-line label-icon align-bottom"></i> Abort
                                            </button>
                                            }
                                            {fboState && fboState.canResetToDraft &&
                                            <button className="btn btn-secondary btn-label"
                                                disabled={loading}
                                                onClick={() => onResetToDraftIsoRequetClick()}
                                            >
                                                <i className="ri-check-double-line label-icon align-bottom"></i> Reset To Draft
                                            </button>
                                            }
                                            {fboState && fboState.canAssignMe &&
                                            <button className="btn btn-primary btn-label"
                                                disabled={loading}
                                                onClick={() => onAssignMeTicketClick()}
                                            >
                                                <i className="ri-user-follow-line label-icon align-bottom"></i> Assign Me ISO Ticket {isContainer ? "Container" : ""}
                                            </button>
                                            }
                                            {fboState && fboState.canProceed && 
                                            <button className="btn btn-dark btn-label"
                                                disabled={loading}
                                                onClick={() => onProceedWithoutPayment()}
                                            >
                                                <i style={{color:"white"}} className="bx bxs-badge-check label-icon align-bottom"></i> Proceed w/o Payment
                                            </button>
                                            }
                                            {fboState && fboState.canNotifyProceed && 
                                            <button className="btn btn-dark btn-label"
                                                disabled={loading}
                                                onClick={() => onNotifyProceedWithoutPayment()}
                                            >
                                                <i style={{color:"white"}} className="ri-notification-line label-icon align-bottom"></i> Notify Proceed w/o Payment
                                            </button>
                                            }
                                        </div>
                                    </div>
                                </CardHeader>
                                <CardBody className="border border-dashed border-end-0 border-start-0">
                                    <Row className="gy-2">
                                        <Col xxl={4} md={6}>
                                            <Label className="form-label">Ticket #</Label>
                                            <input type="text" className="form-control" readOnly={true}
                                                value={(fboState && fboState.isoRequest.requestNumber) || ""}
                                            />
                                        </Col>
                                        <Col xxl={4} md={6}>
                                            <Label className="form-label">Status</Label>
                                            <input type="text" className="form-control" readOnly={true}
                                                value={(fboState && fboState.isoRequest.status) || ""}
                                            />
                                        </Col>
                                        <Col xxl={4} md={6}>
                                            <Label className="form-label">CRM Reference #</Label>
                                            <input type="text" className="form-control" readOnly={true}
                                                value={(fboState && fboState.isoRequest.referenceNumber) || ""}
                                            />
                                        </Col>
                                        {fboState && fboState.showHistoryData &&
                                        <Col xxl={4} md={6}>
                                            <Label className="form-label">Is History Data{fboState && fboState.isHistoryDataRequired && <span className="required">*</span>}</Label>
                                            <select className="form-select" disabled={fboState && fboState.canEditHistoryData ? false : true}
                                                value={(fboState && fboState.isoRequest.isHistoryData) || ""}
                                                onChange={e => onIsoRequestChange("isHistoryData", e.target.value, false)}
                                            >
                                                <option value={""}>...</option>
                                                <option value={"Yes"}>Yes</option>
                                                <option value={"No"}>No</option>
                                            </select>
                                        </Col>
                                        }
                                        {fboState && fboState.showCompany &&
                                        <Col xxl={4} md={6}>
                                            <Label className="form-label">Country{fboState && fboState.isCompanyRequired && <span className="required">*</span>}</Label>
                                            <select className="form-select" disabled={fboState && fboState.canEditCompany ? false : true}
                                                value={(fboState && fboState.isoRequest.countryName) || ""}
                                                onChange={e => onIsoRequestChange("countryName", e.target.value, false)}
                                            >
                                                <option value={""}>...</option>
                                                <option value={"Bahrain"}>Bahrain</option>
                                                <option value={"Egypt"}>Egypt</option>
                                                <option value={"Europe"}>Europe</option>
                                                <option value={"Georgia"}>Georgia</option>
                                                <option value={"India"}>India</option>
                                                <option value={"Jordan"}>Jordan</option>
                                                <option value={"Pakistan"}>Pakistan</option>
                                                <option value={"Saudi Arabia"}>Saudi Arabia</option>
                                                <option value={"Syria"}>Syria</option>
                                                <option value={"Tanzania"}>Tanzania</option>
                                                <option value={"UAE"}>UAE</option>
                                            </select>
                                        </Col>
                                        }
                                        {fboState && fboState.showRegister &&
                                        <Fragment>
                                            <Col xxl={4} md={6}>
                                                <Label className="form-label">TÜV Austria Web{fboState && fboState.isRegisterRequired && <span className="required">*</span>}</Label>
                                                <select className="form-select" disabled={fboState && fboState.canEditRegister ? false : true}
                                                    value={(fboState && fboState.isoRequest.webRegister) || ""}
                                                    onChange={e => onIsoRequestChange("webRegister", e.target.value, false)}
                                                >
                                                    <option value={""}>...</option>
                                                    <option value={"Yes"}>Yes</option>
                                                    <option value={"No"}>No</option>
                                                </select>
                                            </Col>
                                            <Col xxl={4} md={6}>
                                                <Label className="form-label">IAF Registration{fboState && fboState.isRegisterRequired && <span className="required">*</span>}</Label>
                                                <select className="form-select" disabled={fboState && fboState.canEditRegister ? false : true}
                                                    value={(fboState && fboState.isoRequest.iafRegister) || ""}
                                                    onChange={e => onIsoRequestChange("iafRegister", e.target.value, false)}
                                                >
                                                    <option value={""}>...</option>
                                                    <option value={"Yes"}>Yes</option>
                                                    <option value={"No"}>No</option>
                                                </select>
                                            </Col>
                                        </Fragment>
                                        }
                                        <Col xxl={12} md={12}>
                                            <Label className="form-label">Allow Access To <span className="text-primary" style={{fontSize:12}}><i>(Ticket will be shared with other user(s))</i></span></Label>
                                            <Typeahead
                                                id="fldReporterUserIds"
                                                multiple
                                                disabled={fboState && fboState.canEditReporter ? false : true}
                                                labelKey= {option => `${option.fullName}`}
                                                options={fboState && fboState.reporterUserList || []}
                                                placeholder="Select Reporter..."
                                                selected = {selectedReporter}
                                                onChange = {(item) => onReporterChange(item)}
                                            />
                                        </Col>
                                        <Col xxl={12} md={12}>
                                            <Label className="form-label">Remarks</Label>
                                            <input type="text" maxLength={512} className="form-control" placeholder="optional..."
                                                value={(fboState && fboState.isoRequest.description) || ""} readOnly={fboState && fboState.canSave ? false : true}
                                                onChange={e => onIsoRequestChange("description", e.target.value, false)}
                                                onBlur={e => onIsoRequestChange("description", e.target.value, true)}
                                            />
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                            {fboState && fboState.showCertificationAdmin &&
                            <Card className="mb-0">
                                <CardHeader className="border-0 d-flex align-items-center">
                                    <h5 className="card-title mb-0 flex-grow-1">Ticket Users</h5>
                                </CardHeader>
                                <CardBody className="border border-dashed border-end-0 border-start-0">
                                    <Row className="gy-2">
                                        {fboState && fboState.showCertificationAdmin &&
                                        <Col xxl={3} md={6}>
                                            <Label className="form-label">Certification Admin</Label>
                                            <select className="form-select" disabled={fboState && fboState.canEditCertificationAdmin ? false : true}
                                                value={(fboState && fboState.isoRequest.certificationAdminUserId) || ""}
                                                onChange={e => onCertificationAdminUserChange(e.target.value, false)}
                                            >
                                                <option value={0}>...</option>
                                                {fboState && fboState.certificationAdminUserList.map(function(item, index){
                                                    return (
                                                        <option key={index} value={item.id}>{item.fullName}</option>
                                                    );
                                                })}
                                            </select>
                                        </Col>
                                        }
                                        {fboState && fboState.showAuditDocumentReviewer &&
                                        <Col xxl={3} md={6}>
                                            <Label className="form-label">Audit Document Reviewer</Label>
                                            <select className="form-select" disabled={fboState && fboState.canEditAuditDocumentReviewer ? false : true}
                                                value={(fboState && fboState.isoRequest.auditDocumentReviewerUserId) || ""}
                                                onChange={e => onAuditDocumentReviewerUserChange(e.target.value, false)}
                                            >
                                                <option value={0}>...</option>
                                                {fboState && fboState.auditDocumentReviewerUserList.map(function(item, index){
                                                    return (
                                                        <option key={index} value={item.id}>{item.fullName}</option>
                                                    );
                                                })}
                                            </select>
                                        </Col>
                                        }
                                        {fboState && fboState.showTechnicalReviewer &&
                                        <Col xxl={3} md={6}>
                                            <Label className="form-label">Technical Reviewer</Label>
                                            <select className="form-select" disabled={fboState && fboState.canEditTechnicalReviewer ? false : true}
                                                value={(fboState && fboState.isoRequest.technicalReviewerUserId) || ""}
                                                onChange={e => onTechnicalReviewerUserChange(e.target.value, false)}
                                            >
                                                <option value={0}>...</option>
                                                {fboState && fboState.technicalReviewerUserList.map(function(item, index){
                                                    return (
                                                        <option key={index} value={item.id}>{item.fullName}</option>
                                                    );
                                                })}
                                            </select>
                                        </Col>
                                        }
                                        {fboState && fboState.showDecisionMaker &&
                                        <Col xxl={3} md={6}>
                                            <Label className="form-label">Decision Maker</Label>
                                            <select className="form-select" disabled={fboState && fboState.canEditDecisionMaker ? false : true}
                                                value={(fboState && fboState.isoRequest.decisionMakerUserId) || ""}
                                                onChange={e => onDecisionMakerUserChange(e.target.value, false)}
                                            >
                                                <option value={0}>...</option>
                                                {fboState && fboState.decisionMakerUserList.map(function(item, index){
                                                    return (
                                                        <option key={index} value={item.id}>{item.fullName}</option>
                                                    );
                                                })}
                                            </select>
                                        </Col>
                                        }
                                    </Row>
                                </CardBody>
                            </Card>
                            }
                            {fboState && fboState.showCustomer &&
                            <Card className="mb-0">
                                <CardHeader className="border-0 d-flex align-items-center">
                                    <h5 className="card-title mb-0 flex-grow-1">Customer Information</h5>
                                </CardHeader>
                                <CardBody className="border border-dashed border-end-0 border-start-0">
                                    <Row className="gy-2">
                                        <Col xxl={4} md={6}>
                                            <Label className="form-label">CRM Name{fboState && fboState.isCustomerRequired && <span className="required">*</span>}</Label>
                                            <select className="form-select" disabled={fboState && fboState.canEditCustomer ? false : true}
                                                value={(fboState && fboState.isoRequest.crmName) || ""}
                                                onChange={e => onIsoRequestChange("crmName", e.target.value, false)}
                                            >
                                                <option value="">...</option>
                                                {fboState && fboState.crmList.map(function(item, index){
                                                    return (
                                                        <option key={index} value={item.crmName}>{item.crmLabel}</option>
                                                    );
                                                })}
                                            </select>
                                        </Col>
                                        <Col xxl={4} md={6}>
                                            <Label className="form-label">Invoice Country{fboState && fboState.isCustomerRequired && <span className="required">*</span>}</Label>
                                            <select className="form-select" disabled={fboState && fboState.canEditCustomer ? false : true}
                                                value={(fboState && fboState.isoRequest.crmCountry) || ""}
                                                onChange={e => onIsoRequestChange("crmCountry", e.target.value, false)}
                                            >
                                                <option value="">...</option>
                                                {fboState && fboState.crmCountryList.filter(x => x.crmName == fboState.isoRequest.crmName).map(function(item, index){
                                                    return (
                                                        <option key={index} value={item.countryName}>{item.countryLabel}</option>
                                                    );
                                                })}
                                            </select>
                                        </Col>
                                        <Col xxl={4} md={6}>&nbsp;</Col>
                                        {(fboState && fboState.canEditCustomer) === false &&
                                        <Col xxl={4} md={6}>
                                            <Label className="form-label">Customer Code</Label>
                                            <input type="text" className="form-control" readOnly={true}
                                                value={(selectedCustomer.length > 0 && selectedCustomer[0].code + ' - ' + selectedCustomer[0].crmCountry) || ""}
                                            />
                                        </Col>
                                        }
                                        {(fboState && fboState.canEditCustomer) === true &&
                                        <Col xxl={4} md={6}>
                                            <Label className="form-label">Customer Code{fboState && fboState.isCustomerRequired && <span className="required">*</span>}</Label>
                                            <CustomerLookup
                                                id ="fldCustomerLookup2"
                                                crmName={(fboState && fboState.isoRequest.crmName) || ""}
                                                selected = {selectedCustomer}
                                                onChange = {(item) => onCustomerChange(item)}
                                            />
                                        </Col>
                                        }
                                        <Col xxl={4} md={6}>
                                            <Label className="form-label">Organization Name</Label>
                                            <input type="text" className="form-control" readOnly={true}
                                                value={(selectedCustomer.length > 0 && selectedCustomer[0].organizationName) || ""}
                                            />
                                        </Col>
                                        <Col xxl={4} md={6}>
                                            <Label className="form-label">Contact Name</Label>
                                            <input type="text" className="form-control" readOnly={true}
                                                value={(selectedCustomer.length > 0 && selectedCustomer[0].fullName) || ""}
                                            />
                                        </Col>
                                        <Col xxl={4} md={6}>
                                            <Label className="form-label">Email</Label>
                                            <input type="text" className="form-control" readOnly={true}
                                                value={(selectedCustomer.length > 0 && selectedCustomer[0].email) || ""}
                                            />
                                        </Col>
                                        <Col xxl={4} md={6}>
                                            <Label className="form-label">Phone Number</Label>
                                            <input type="text" className="form-control" readOnly={true}
                                                value={(selectedCustomer.length > 0 && selectedCustomer[0].telephoneNumber) || ""}
                                            />
                                        </Col>
                                        <Col xxl={4} md={6}>
                                            <Label className="form-label">Fax Number</Label>
                                            <input type="text" className="form-control" readOnly={true}
                                                value={(selectedCustomer.length > 0 && selectedCustomer[0].faxNumber) || ""}
                                            />
                                        </Col>
                                        <Col xxl={12} md={12}>
                                            <Label className="form-label">Address</Label>
                                            <input type="text" className="form-control" readOnly={true}
                                                value={(selectedCustomer.length > 0 && selectedCustomer[0].fullAddress) || ""}
                                            />
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                            }
                            {fboState && fboState.showInvoice &&
                            <Card className="mb-0 card-light">
                                <CardHeader className="border-0 d-flex align-items-center">
                                    <h5 className="card-title mb-0 flex-grow-1 cursor-pointer" onClick={() => setInvoiceInformationCollapsed(!invoiceInformationCollapsed)}>
                                        {invoiceInformationCollapsed && <i className="ri-add-box-line align-bottom text-primary"></i>}
                                        {!invoiceInformationCollapsed && <i className="ri-checkbox-indeterminate-line align-bottom text-primary"></i>}
                                        Invoice Information{fboState && fboState.isInvoiceRequired && <span className="required">*</span>} {fboState && fboState.isoRequest.isPaid === false && fboState.isoRequest.invoiceProceed === true ? "[Proceed without Payment] " : ""}({invoiceInformationCollapsed ? "Expand" : "Collapse"})
                                    </h5>
                                </CardHeader>
                                <CardBody className="border border-dashed border-end-0 border-start-0 card-text">
                                    <Collapse isOpen={!invoiceInformationCollapsed} className="collapse">
                                        <Row className="gy-2">
                                            <Col xxl={2} md={6}>
                                                <Label className="form-label">Currency</Label>
                                                <select className="form-select" disabled={true}
                                                    value={(fboState && fboState.isoRequest.currency) || ""}
                                                    onChange={e => onIsoRequestChange("currency", e.target.value, false)}
                                                >
                                                    <option value={""}>...</option>
                                                    <option value="AED">UAE Dirham</option>
                                                    <option value="CNY">China Yuan</option>
                                                    <option value="EUR">Euro</option>
                                                    <option value="USD">USA Dollar</option>
                                                    <option value="LKR">Sri Lanka Rupee</option>
                                                    <option value="EGP">Egypt Pound</option>
                                                    <option value="SAR">Saudi Riyal</option>
                                                    <option value="INR">India Rupee</option>
                                                </select>
                                            </Col>
                                        </Row>
                                        {fboState && fboState.isoRequest && fboState.isoRequest.payments && fboState.isoRequest.payments.map(function(payment, index) {
                                            return(
                                                <Fragment key={index}>
                                                    <Row className="gy-2">
                                                        <Col xxl={12} md={12}>
                                                            <hr />
                                                        </Col>
                                                    </Row>
                                                    <Row className="gy-2">
                                                        <Col xxl={4} md={6}>
                                                            <Label className="form-label">CRM Invoice #</Label>
                                                            <input type="text" className="form-control" readOnly={true}
                                                                value={(payment.crmInvoiceNumber) || ""}
                                                            />
                                                        </Col>
                                                        <Col xxl={4} md={6}>
                                                            <Label className="form-label">Tax Invoice #</Label>
                                                            <input type="text" className="form-control" readOnly={true}
                                                                value={(payment.taxInvoiceNumber) || ""}
                                                            />
                                                        </Col>
                                                        <Col xxl={2} md={6}>
                                                            <Label className="form-label">Status</Label>
                                                            <input type="text" className="form-control" readOnly={true}
                                                                value={(payment.invoiceStatus) || ""}
                                                            />
                                                        </Col>
                                                        <Col xxl={2} md={6}>
                                                            <Label className="form-label">ISO Date</Label>
                                                            <input type="text" className="form-control" readOnly={true}
                                                                value={getFormattedDate(payment.isoDate) || ""}
                                                            />
                                                        </Col>
                                                        <Col xxl={4} md={6}>
                                                            <Label className="form-label">Product Name</Label>
                                                            <input type="text" className="form-control" readOnly={true}
                                                                value={(payment.productName) || ""}
                                                            />
                                                        </Col>
                                                        <Col xxl={2} md={6}>
                                                            <Label className="form-label">Price</Label>
                                                            <input type="text" className="form-control" readOnly={true}
                                                                value={(payment.fee) || ""}
                                                            />
                                                        </Col>
                                                        <Col xxl={2} md={6}>
                                                            <Label className="form-label">VAT Amount</Label>
                                                            <input type="text" className="form-control" readOnly={true}
                                                                value={(payment.vat) || ""}
                                                            />
                                                        </Col>
                                                        <Col xxl={2} md={6}>
                                                            <Label className="form-label">Total Price</Label>
                                                            <input type="text" className="form-control" readOnly={true}
                                                                value={(payment.total) || ""}
                                                            />
                                                        </Col>
                                                        <Col xxl={2} md={6}>
                                                            <Label className="form-label">Payment Percentage</Label>
                                                            <input type="text" className="form-control" readOnly={true}
                                                                value={(payment.payment) || ""}
                                                            />
                                                        </Col>
                                                    </Row>
                                                    <Row className="gy-2">
                                                        <Col className="text-end pt-3">
                                                            {fboState && fboState.canRemoveInvoice && 
                                                            <button className="btn btn-danger btn-label me-2" onClick={() => onRemoveInvoice(payment.id)}>
                                                                <i className="ri-bill-line label-icon align-bottom"></i> Remove Invoice
                                                            </button>
                                                            }
                                                            <button type="button" className="btn btn-primary btn-label" data-dismiss="modal" onClick={() => onViewInvoice(payment.crmInvoiceId)}>
                                                                <i className="ri-bill-line label-icon align-bottom"></i> View Invoice
                                                            </button>
                                                        </Col>
                                                    </Row>
                                                </Fragment>
                                            );
                                        })}
                                    </Collapse>
                                </CardBody>
                            </Card>
                            }
                            {fboState && fboState.showCustomerParty &&
                            <Card className="mb-0">
                                <CardHeader className="border-0 d-flex align-items-center">
                                    <h5 className="card-title mb-0 flex-grow-1">Certified Party (Sales)</h5>
                                </CardHeader>
                                <CardBody className="border border-dashed border-end-0 border-start-0">
                                    <Row className="gy-2">
                                        <Col xxl={4} md={12}>
                                            <Label className="form-label">Certified Company Name{fboState.isCustomerPartyRequired && <span className="required">*</span>}</Label>
                                            <input type="text" maxLength={256} className="form-control" readOnly={fboState.canEditCustomerParty ? false : true}
                                                value={(fboState.isoRequest.customerName) || ""}
                                                onChange={e => onIsoRequestChange("customerName", e.target.value, false)}
                                                onBlur={e => onIsoRequestChange("customerName", e.target.value, true)}
                                            />
                                        </Col>
                                        <Col xxl={8} md={12}>
                                            <Label className="form-label">Certified Company Address{fboState.isCustomerPartyRequired && <span className="required">*</span>}</Label>
                                            <input type="text" maxLength={256} className="form-control" readOnly={fboState.canEditCustomerParty ? false : true}
                                                value={(fboState.isoRequest.customerAddress) || ""}
                                                onChange={e => onIsoRequestChange("customerAddress", e.target.value, false)}
                                                onBlur={e => onIsoRequestChange("customerAddress", e.target.value, true)}
                                            />
                                        </Col>
                                        <Col xxl={12} md={12}>
                                            <Label className="form-label">Company Description{fboState.isCustomerPartyRequired && <span className="required">*</span>}</Label>
                                            <input type="text" maxLength={256} className="form-control" readOnly={fboState.canEditCustomerParty ? false : true}
                                                value={(fboState.isoRequest.customerDescription) || ""}
                                                onChange={e => onIsoRequestChange("customerDescription", e.target.value, false)}
                                                onBlur={e => onIsoRequestChange("customerDescription", e.target.value, true)}
                                            />
                                        </Col>
                                        <Col xxl={4} md={12}>
                                            <Label className="form-label">Company Representative Name</Label>
                                            <input type="text" maxLength={256} className="form-control" readOnly={fboState.canEditCustomerParty ? false : true}
                                                value={(fboState.isoRequest.customerContactName) || ""}
                                                onChange={e => onIsoRequestChange("customerContactName", e.target.value, false)}
                                                onBlur={e => onIsoRequestChange("customerContactName", e.target.value, true)}
                                            />
                                        </Col>
                                        <Col xxl={4} md={12}>
                                            <Label className="form-label">Company Representative Email</Label>
                                            <input type="text" maxLength={256} className="form-control" readOnly={fboState.canEditCustomerParty ? false : true}
                                                value={(fboState.isoRequest.customerContactEmail) || ""}
                                                onChange={e => onIsoRequestChange("customerContactEmail", e.target.value, false)}
                                                onBlur={e => onIsoRequestChange("customerContactEmail", e.target.value, true)}
                                            />
                                        </Col>
                                        <Col xxl={4} md={12}>
                                            <Label className="form-label">Company Representative Phone</Label>
                                            <input type="text" maxLength={256} className="form-control" readOnly={fboState.canEditCustomerParty ? false : true}
                                                value={(fboState.isoRequest.customerContactPhone) || ""}
                                                onChange={e => onIsoRequestChange("customerContactPhone", e.target.value, false)}
                                                onBlur={e => onIsoRequestChange("customerContactPhone", e.target.value, true)}
                                            />
                                        </Col>
                                        <Col xxl={12} md={12}>
                                            <Label className="form-label">Certification Scope{fboState.isCustomerPartyRequired && <span className="required">*</span>}</Label>
                                            <textarea maxLength={4000} className="form-control" rows="5" readOnly={fboState.canEditCustomerParty ? false : true}
                                                value={(fboState.isoRequest.certificationScope) || ""}
                                                onChange={e => onIsoRequestChange("certificationScope", e.target.value, false)}
                                                onBlur={e => onIsoRequestChange("certificationScope", e.target.value, true)}
                                            />
                                        </Col>
                                        <Col xxl={12} md={12} className="m-0 align-right" style={{textAlign:"right"}}>
                                            <Label className="form-label">{fboState && fboState.isoRequest.certificationScope && fboState.isoRequest.certificationScope.length || "0"} of 4000</Label>
                                        </Col>
                                        <Col xxl={12} md={12}>
                                            <Label className="form-label">Sub Location(s)</Label>
                                        </Col>
                                        {fboState && fboState.isoRequest.locations.map(function(item, index){
                                            return (
                                                <Row className={`gy-1 ${item.isDeleted ? "d-none" : ""}`} key={index}>
                                                    <Col xxl={11} md={11} className="pe-1">
                                                        <input type="text" className="form-control" readOnly={fboState.canEditCustomerParty ? false : true}
                                                            value={item.locationAddress || ""}
                                                            onChange={e => onIsoRequestLocationChange(index, "locationAddress", e.target.value, false)}
                                                            onBlur={e => onIsoRequestLocationChange(index, "locationAddress", e.target.value, true)}
                                                        />
                                                    </Col>
                                                    <Col xxl={1} md={1} className="p-0">
                                                        {fboState.canEditCustomerParty && index === 0 &&
                                                        <button type="button" className="btn btn-primary btn-sm me-1 mt-1" title="Add Sub Location"
                                                            onClick={() => onIsoRequestLocationAdd()}
                                                        >
                                                            <i className="ri-add-line" />
                                                        </button>
                                                        }
                                                        {fboState.canEditCustomerParty && index > 0 &&
                                                        <button type="button" className="btn btn-danger btn-sm me-1 mt-1" title="Remove Sub Location"
                                                            onClick={() => onIsoRequestLocationChange(index, "isDeleted", true, false)}
                                                        >
                                                            <i className="ri-delete-bin-2-line" />
                                                        </button>
                                                        }
                                                    </Col>
                                                </Row>
                                            );
                                        })}
                                    </Row>
                                </CardBody>
                            </Card>
                            }

                            {fboState && fboState.isoRequest.id > 0 && isContainer &&
                                <IsoRequestGrid refId={fboState.isoRequest.id} />
                            }
                            
                            {fboState && fboState.showCertificateTab &&
                            <Card className="mt-3 mb-3">
                                <CardHeader className="border-0 d-flex align-items-center">
                                    <h5 className="card-title mb-0 flex-grow-1">Certificate(s)</h5>
                                    <div className="flex-shrink-0">
                                        <div className="d-flex flex-wrap gap-2">
                                            {fboState && fboState.canAddCertificateTab &&
                                            <button className="btn btn-primary btn-label"
                                                onClick={() => onCertificateAdd()}
                                            >
                                                <i className="ri-add-line label-icon align-bottom"></i> Add Standard
                                            </button>
                                            }
                                        </div>
                                    </div>
                                </CardHeader>
                                <CardBody className="border border-dashed border-end-0 border-start-0">
                                    <Row className="gy-2">
                                        {fboState && fboState.isoRequest.certificates.length === 0 && <Col xxl={12} md={12}><Label className="form-label">No Certificate added.</Label></Col>}
                                        <div style={{ overflowX: "auto", whiteSpace: "nowrap" }}>
                                            <Nav tabs className="nav nav-tabs nav-tabs-custom arrow-navtabs nav-success nav-justified mb-3" style={{ flexWrap: "nowrap", minWidth: "max-content" }}>
                                                {fboState && fboState.isoRequest.certificates.map(function(certificate, certificateIndex){
                                                    return (
                                                        <NavItem key={certificateIndex}>
                                                            <NavLink style={{ cursor: "pointer" }} className={activeTab === certificateIndex ? "active" : ""} onClick={() => { toggleTab(certificateIndex); }} >
                                                                <div className="d-flex justify-content-center">
                                                                    <div className="d-flex align-items-center">
                                                                        <div
                                                                            style={{
                                                                                width: "12px",
                                                                                height: "12px",
                                                                                borderRadius: "50%",
                                                                                backgroundColor: getColorByGroup(certificate.groupId),
                                                                                flexShrink: 0,
                                                                                marginRight: "5px"
                                                                            }}
                                                                        />
                                                                        <div style={{display: "flex", flexDirection: "column", width: "100%"}}>
                                                                            <span>
                                                                                Certificate #
                                                                            </span>
                                                                            <span style={{whiteSpace: "nowrap"}}>
                                                                                {certificate.certificate.certificateNumber || certificate.id}
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                    
                                                                </div>
                                                            </NavLink>
                                                        </NavItem>
                                                    );
                                                })}
                                            </Nav>
                                        </div>
                                        <TabContent activeTab={activeTab} className="text-muted">
                                            {fboState && fboState.isoRequest.certificates.map(function(certificate, certificateIndex){
                                                return (
                                                    <TabPane tabId={certificateIndex} key={certificateIndex}>
                                                        {fboState && fboState.canRemoveCertificateTab &&
                                                        <Row className="gy-2">
                                                            <Col xxl={12} md={12} className="text-end">
                                                                <button className="btn btn-danger btn-label"
                                                                    onClick={() => onRemoveCertificate(certificate.id)}
                                                                >
                                                                    <i className="ri-delete-bin-2-line label-icon align-bottom"></i> Remove Standard
                                                                </button>
                                                            </Col>
                                                        </Row>
                                                        }
                                                        <Row className="gy-2">
                                                            <Col xxl={3} md={6}>
                                                                <Label className="form-label">Request Type</Label>
                                                                <select className="form-select" disabled={true}
                                                                    value={(certificate.requestType) || ""}
                                                                >
                                                                    <option value={""}>...</option>
                                                                    {fboState && fboState.requestTypeList.map(function(item, index){
                                                                        return (
                                                                            <option key={index} value={item.code}>{item.description}</option>
                                                                        );
                                                                    })}
                                                                </select>
                                                            </Col>
                                                            {certificate.requestType == "Other Audit" &&
                                                            <Col xxl={3} md={6}>
                                                                <Label className="form-label">Other Audit Name{certificate.isRequestTypeOtherRequired && <span className="required">*</span>}</Label>
                                                                <input type="text" className="form-control" readOnly={certificate.canEditRequestTypeOther ? false : true}
                                                                    value={certificate.requestTypeOther || ""}
                                                                    onChange={e => onRequestCertificateChange(certificateIndex, "requestTypeOther", e.target.value, false)}
                                                                />
                                                            </Col>
                                                            }
                                                            <Col xxl={3} md={6}>
                                                                <Label className="form-label">Accreditation Type{certificate.isAccredationTypeRequired && <span className="required">*</span>}</Label>
                                                                <select className="form-select" disabled={certificate.canEditAccredationType ? false : true}
                                                                    value={(certificate.certificate.accreditationType) || ""}
                                                                    onChange={e => onCertificateChange(certificateIndex, "accreditationType", e.target.value, false)}
                                                                >
                                                                    <option value={""}>...</option>
                                                                    <option value={"SAC"}>SAC</option>
                                                                    <option value={"Hellas"}>Hellas</option>
                                                                    <option value={"Vienna"}>Vienna</option>
                                                                    <option value={"Unaccredited"}>Unaccredited</option>
                                                                </select>
                                                            </Col>
                                                        </Row>
                                                        {(certificate.showSchedulingResponsible || certificate.showMdcIssuer || certificate.showCaseLeader) &&
                                                        <Card className="mb-0 card-light mt-3">
                                                            <CardHeader className="border-0 d-flex align-items-center">
                                                                <h5 className="card-title mb-0 flex-grow-1">Case Management Users</h5>
                                                            </CardHeader>
                                                            <CardBody className="border border-dashed border-end-0 border-start-0 card-text">
                                                                <Row className="gy-2">
                                                                    {certificate.showSchedulingResponsible &&
                                                                    <Col xxl={4} md={6}>
                                                                        <Label className="form-label">Scheduling Responsible{certificate.isSchedulingResponsibleRequired && <span className="required">*</span>}</Label>
                                                                        <select className="form-select" disabled={certificate.canEditSchedulingResponsible && certificate.groupId === certificate.id ? false : true}
                                                                            value={(certificate.schedulingResponsibleUserId) || ""}
                                                                            onChange={e => onSchedulingResponsibleUserChange(certificateIndex, e.target.value, false)}
                                                                        >
                                                                            <option value={0}>...</option>
                                                                            {certificate.schedulingResponsibleUserList.map(function(item, index){
                                                                                return (
                                                                                    <option key={index} value={item.id}>{item.fullName}</option>
                                                                                );
                                                                            })}
                                                                        </select>
                                                                    </Col>
                                                                    }
                                                                    {certificate.showMdcIssuer &&
                                                                    <Col xxl={4} md={6}>
                                                                        <Label className="form-label">Mdc Issuer{certificate.isMdcIssuerRequired && <span className="required">*</span>}</Label>
                                                                        <select className="form-select" disabled={certificate.canEditMdcIssuer && certificate.groupId === certificate.id ? false : true}
                                                                            value={(certificate.mdcIssuerUserId) || ""}
                                                                            onChange={e => onMdcIssuerUserChange(certificateIndex, e.target.value, false)}
                                                                        >
                                                                            <option value={0}>...</option>
                                                                            {certificate.certificate.accreditationType === "SAC" && certificate.sacMdcIssuerUserList.map(function(item, index){
                                                                                    return (
                                                                                        <option key={index} value={item.id}>{item.fullName}</option>
                                                                                    );
                                                                                })
                                                                            }
                                                                            {certificate.certificate.accreditationType != "SAC" && certificate.nonSacMdcIssuerUserList.map(function(item, index){
                                                                                    return (
                                                                                        <option key={index} value={item.id}>{item.fullName}</option>
                                                                                    );
                                                                                })
                                                                            }
                                                                        </select>
                                                                    </Col>
                                                                    }
                                                                    {certificate.showCaseLeader &&
                                                                    <Col xxl={4} md={6}>
                                                                        <Label className="form-label">Case Leader{certificate.isCaseLeaderRequired && <span className="required">*</span>}</Label>
                                                                        <select className="form-select" disabled={certificate.canEditCaseLeader && certificate.groupId === certificate.id ? false : true}
                                                                            value={(certificate.caseLeaderUserId) || ""}
                                                                            onChange={e => onCaseLeaderUserChange(certificateIndex, e.target.value, false)}
                                                                        >
                                                                            <option value={0}>...</option>
                                                                            {certificate.caseLeaderUserList.map(function(item, index){
                                                                                return (
                                                                                    <option key={index} value={item.id}>{item.fullName}</option>
                                                                                );
                                                                            })}
                                                                        </select>
                                                                    </Col>
                                                                    }
                                                                </Row>
                                                            </CardBody>
                                                        </Card>
                                                        }
                                                        {fboState && fboState.showManDay &&
                                                        <Card className="mb-0 card-light mt-3">
                                                            <CardHeader className="border-0 d-flex align-items-center">
                                                                <h5 className="card-title mb-0 flex-grow-1">Man Day Calculation{(certificate.isManDayStandardRequired || certificate.isManDayOtherRequired) && <span className="required">*</span>}</h5>
                                                            </CardHeader>
                                                            <CardBody className="border border-dashed border-end-0 border-start-0 card-text">
                                                                <Row className="gy-2">
                                                                    <Col xxl={3} md={12}>
                                                                        <Label className="form-label">Audit Type{certificate.isManDayOtherRequired && <span className="required">*</span>}</Label>
                                                                        <select className="form-select" disabled={certificate.canEditManDayOther ? false : true}
                                                                            value={(certificate.manDay.auditType) || ""}
                                                                            onChange={e => onManDayChange(certificateIndex, "auditType", e.target.value, false)}
                                                                        >
                                                                            <option value={""}>...</option>
                                                                            {fboState && fboState.auditTypeList.map(function(item, index){
                                                                                return (
                                                                                    <option key={index} value={item.code}>{item.description}</option>
                                                                                );
                                                                            })}
                                                                        </select>
                                                                    </Col>
                                                                    <Col xxl={3} md={12}>
                                                                        <Label className="form-label">Audit Kind{certificate.isManDayOtherRequired && <span className="required">*</span>}</Label>
                                                                        <select className="form-select" disabled={certificate.canEditManDayOther ? false : true}
                                                                            value={(certificate.manDay.auditKind) || ""}
                                                                            onChange={e => onManDayChange(certificateIndex, "auditKind", e.target.value, false)}
                                                                        >
                                                                            <option value={""}>...</option>
                                                                            <option value={"Single Audit"}>Single Audit</option>
                                                                            <option value={"Integrated Audit"}>Integrated Audit</option>
                                                                            <option value={"Combined Audit"}>Combined Audit</option>
                                                                            <option value={"Joint Audit"}>Joint Audit</option>
                                                                            <option value={"Multisites"}>Multisites</option>
                                                                        </select>
                                                                    </Col>
                                                                    {certificate.manDay.auditKind === "Integrated Audit" && (certificate.certificate.accreditationType === "SAC" || certificate.certificate.accreditationType === "Unaccredited") &&
                                                                    <Col xxl={3} md={12}>
                                                                        <Label className="form-label">Integrated with Certificate #</Label>
                                                                        <select className="form-select" disabled={certificate.canEditManDayOther ? false : true}
                                                                            value={(certificate.groupId) || ""}
                                                                            onChange={e => onRequestCertificateChange(certificateIndex, "groupId", e.target.value, false)}
                                                                        >
                                                                            <option value={certificate.id}>...</option>
                                                                            {getIntegratedCertificateList(certificate.id, certificate.certificate.accreditationType).map(function(item, itemIndex){
                                                                                return (
                                                                                    <option key={itemIndex} value={item.id}>{item.certificate.certificateNumber || item.id}</option>
                                                                                );
                                                                            })}
                                                                        </select>
                                                                    </Col>
                                                                    }
                                                                    <Col xxl={3} md={12}>
                                                                        <Label className="form-label">Audit Language{certificate.isManDayOtherRequired && <span className="required">*</span>}</Label>
                                                                        <select className="form-select" disabled={certificate.canEditManDayOther ? false : true}
                                                                            value={(certificate.manDay.auditLanguage) || ""}
                                                                            onChange={e => onManDayChange(certificateIndex, "auditLanguage", e.target.value, false)}
                                                                        >
                                                                            <option value={""}>...</option>
                                                                            <option value={"English"}>English</option>
                                                                            <option value={"Arabic"}>Arabic</option>
                                                                            <option value={"Other"}>Other</option>
                                                                        </select>
                                                                    </Col>
                                                                    {certificate.manDay.auditLanguage === "Other" &&
                                                                    <Col xxl={3} md={12}>
                                                                        <Label className="form-label">Language{certificate.isManDayOtherRequired && <span className="required">*</span>}</Label>
                                                                        <input type="text" className="form-control" readOnly={certificate.canEditManDayOther ? false : true}
                                                                            value={certificate.manDay.auditLanguageOther || ""}
                                                                            onChange={e => onManDayChange(certificateIndex, "auditLanguageOther", e.target.value, false)}
                                                                            onBlur={e => onManDayChange(certificateIndex, "auditLanguageOther", e.target.value, true)}
                                                                        />
                                                                    </Col>
                                                                    }
                                                                </Row>
                                                                <Row className="gy-2">
                                                                    <Col xxl={3} md={12}>
                                                                        <Label className="form-label">Man Day Standard{certificate.isManDayStandardRequired && <span className="required">*</span>}</Label>
                                                                        <Select 
                                                                            placeholder="..."
                                                                            isClearable={true}
                                                                            isSearchable={true}
                                                                            isDisabled={certificate.canEditManDayStandard ? false : true}
                                                                            value={fboState && fboState.manDayStandardList.find(x => x.id.toString() === certificate.manDay.manDayStandardId?.toString()) || null}
                                                                            onChange={option => onManDayChange(certificateIndex, "manDayStandardId", (option?.id ?? null), false)}
                                                                            options={fboState && fboState.manDayStandardList.filter(x => x.accreditationType == certificate.certificate.accreditationType) || []}
                                                                            getOptionValue={option => option.id.toString()}
                                                                            getOptionLabel={option => option.standardShortName}
                                                                        />
                                                                    </Col>
                                                                    <Col xxl={3} md={12}>
                                                                        <Label className="form-label">Number Of Personnel{certificate.isManDayOtherRequired && <span className="required">*</span>}</Label>
                                                                        {certificate.certificate.accreditationType === "SAC" &&
                                                                        <select 
                                                                            className="form-select" disabled={certificate.canEditManDayOther ? false : true}
                                                                            value={certificate.manDay.personCount || ""}
                                                                            onChange={e => onManDayChange(certificateIndex, "personCount", e.target.value, false)}
                                                                        >
                                                                            <option value={""}>...</option>
                                                                            {fboState && fboState.manDayStandardConfigurationList.filter(x => x.manDayStandardId == certificate.manDay.manDayStandardId).map(function(configItem, configIndex){
                                                                                return (
                                                                                    <option key={configIndex} value={configItem.personnelDisplay}>{configItem.personnelDisplay}</option>
                                                                                );
                                                                            })}
                                                                        </select>
                                                                        }
                                                                        {certificate.certificate.accreditationType !== "SAC" &&
                                                                        <input type="text" className="form-control" readOnly={certificate.canEditManDayOther ? false : true}
                                                                            value={certificate.manDay.personCount || ""}
                                                                            onChange={e => onManDayChange(certificateIndex, "personCount", e.target.value, false)}
                                                                            onBlur={e => onManDayChange(certificateIndex, "personCount", e.target.value, true)}
                                                                        />
                                                                        }
                                                                    </Col>
                                                                    <Col xxl={2} md={12}>
                                                                        <Label className="form-label">Complexity{certificate.isManDayOtherRequired && <span className="required">*</span>}</Label>
                                                                        <select 
                                                                            className="form-select" disabled={certificate.canEditManDayOther ? false : true}
                                                                            value={certificate.manDay.complexity || ""}
                                                                            onChange={e => onManDayChange(certificateIndex, "complexity", e.target.value)}
                                                                        >
                                                                            <option value="">...</option>
                                                                            <option value="Low">Low</option>
                                                                            <option value="Medium">Medium</option>
                                                                            <option value="High">High</option>   
                                                                            
                                                                        </select>
                                                                    </Col>
                                                                    <Col xxl={2} md={12}>
                                                                        <Label className="form-label">Man Days{certificate.isManDayOtherRequired && <span className="required">*</span>}</Label>
                                                                        <input type="text" className="form-control" readOnly={certificate.canEditManDayOther ? false : true}
                                                                            value={certificate.manDay.complexityValue || ""}
                                                                            onChange={e => onManDayChange(certificateIndex, "complexityValue", e.target.value, false)}
                                                                            onBlur={e => onManDayChange(certificateIndex, "complexityValue", e.target.value, true)}
                                                                        />
                                                                    </Col>
                                                                    <Col xxl={2} md={12}>
                                                                        <Label className="form-label">Audit Hours{certificate.isManDayOtherRequired && <span className="required">*</span>}</Label>
                                                                        <input type="text" className="form-control" readOnly={certificate.canEditManDayOther ? false : true}
                                                                            value={certificate.manDay.auditHour || ""}
                                                                            onChange={e => onManDayChange(certificateIndex, "auditHour", e.target.value, false)}
                                                                            onBlur={e => onManDayChange(certificateIndex, "auditHour", e.target.value, true)}
                                                                        />
                                                                    </Col>
                                                                </Row>
                                                                <Row className="gy-2">
                                                                    <Col xxl={3} md={12}>
                                                                        <Label className="form-label">Increase/Decrease Factors</Label>
                                                                        <input type="text" maxLength={256} className="form-control" readOnly={certificate.canEditManDayOther ? false : true}
                                                                            value={certificate.manDay.factorDescription || ""}
                                                                            onChange={e => onManDayChange(certificateIndex, "factorDescription", e.target.value, false)}
                                                                            onBlur={e => onManDayChange(certificateIndex, "factorDescription", e.target.value, true)}
                                                                        />
                                                                    </Col>
                                                                    <Col xxl={3} md={12}>
                                                                        <Label className="form-label">Factor Type</Label>
                                                                        <select 
                                                                            className="form-select" disabled={certificate.canEditManDayOther ? false : true}
                                                                            value={certificate.manDay.factorValue || ""}
                                                                            onChange={e => onManDayChange(certificateIndex, "factorValue", e.target.value)}
                                                                        >
                                                                            <option value="">...</option>
                                                                            <option value="Increase">Increase</option>
                                                                            <option value="Decrease">Decrease</option>                                                                            
                                                                        </select>
                                                                    </Col>
                                                                    <Col xxl={2} md={12}>
                                                                        <Label className="form-label">Percentage %</Label>
                                                                        <input type="text" maxLength={256} className="form-control" readOnly={certificate.canEditManDayOther ? false : true}
                                                                            value={certificate.manDay.factorPercentage || ""}
                                                                            onChange={e => onManDayChange(certificateIndex, "factorPercentage", e.target.value, false)}
                                                                            onBlur={e => onManDayChange(certificateIndex, "factorPercentage", e.target.value, true)}
                                                                        />
                                                                    </Col>
                                                                    <Col xxl={2} md={12}>
                                                                        <Label className="form-label">Man Days after Factor</Label>
                                                                        <input type="text" maxLength={256} className="form-control" readOnly={certificate.canEditManDayOther ? false : true}
                                                                            value={certificate.manDay.factorComplexityValue || ""}
                                                                            onChange={e => onManDayChange(certificateIndex, "factorComplexityValue", e.target.value, false)}
                                                                            onBlur={e => onManDayChange(certificateIndex, "factorComplexityValue", e.target.value, true)}
                                                                        />
                                                                    </Col>
                                                                    <Col xxl={2} md={12}>
                                                                        <Label className="form-label">Audit Hours after Factor</Label>
                                                                        <input type="text" maxLength={256} className="form-control" readOnly={certificate.canEditManDayOther ? false : true}
                                                                            value={certificate.manDay.factorAuditHour || ""}
                                                                            onChange={e => onManDayChange(certificateIndex, "factorAuditHour", e.target.value, false)}
                                                                            onBlur={e => onManDayChange(certificateIndex, "factorAuditHour", e.target.value, true)}
                                                                        />
                                                                    </Col>
                                                                </Row>
                                                            </CardBody>
                                                        </Card>
                                                        }
                                                        {fboState && fboState.showCertifiedParty &&
                                                        <Card className="mb-0 card-light mt-3">
                                                            <CardHeader className="border-0 d-flex align-items-center">
                                                                <h5 className="card-title mb-0 flex-grow-1">Certified Party{certificate.isCertifiedPartyRequired && <span className="required">*</span>}</h5>
                                                            </CardHeader>
                                                            <CardBody className="border border-dashed border-end-0 border-start-0 card-text">
                                                                <Row className="gy-2">
                                                                    <Col xxl={4} md={12}>
                                                                        <Label className="form-label">Certified Company Name{certificate.isCertifiedPartyRequired && <span className="required">*</span>}</Label>
                                                                        <input type="text" maxLength={256} className="form-control" readOnly={certificate.canEditCertifiedParty ? false : true}
                                                                            value={(certificate.certificate.customerName) || ""}
                                                                            onChange={e => onCertificateChange(certificateIndex, "customerName", e.target.value, false)}
                                                                            onBlur={e => onCertificateChange(certificateIndex, "customerName", e.target.value, true)}
                                                                        />
                                                                    </Col>
                                                                    <Col xxl={8} md={12}>
                                                                        <Label className="form-label">Certified Company Address{certificate.isCertifiedPartyRequired && <span className="required">*</span>}</Label>
                                                                        <input type="text" maxLength={256} className="form-control" readOnly={certificate.canEditCertifiedParty ? false : true}
                                                                            value={(certificate.certificate.customerAddress) || ""}
                                                                            onChange={e => onCertificateChange(certificateIndex, "customerAddress", e.target.value, false)}
                                                                            onBlur={e => onCertificateChange(certificateIndex, "customerAddress", e.target.value, true)}
                                                                        />
                                                                    </Col>
                                                                    <Col xxl={12} md={12}>
                                                                        <Label className="form-label">Company Description{certificate.isCertifiedPartyRequired && <span className="required">*</span>}</Label>
                                                                        <input type="text" maxLength={256} className="form-control" readOnly={certificate.canEditCertifiedParty ? false : true}
                                                                            value={(certificate.certificate.customerDescription) || ""}
                                                                            onChange={e => onCertificateChange(certificateIndex, "customerDescription", e.target.value, false)}
                                                                            onBlur={e => onCertificateChange(certificateIndex, "customerDescription", e.target.value, true)}
                                                                        />
                                                                    </Col>
                                                                    <Col xxl={4} md={12}>
                                                                        <Label className="form-label">Company Representative Name</Label>
                                                                        <input type="text" maxLength={256} className="form-control" readOnly={certificate.canEditCertifiedParty ? false : true}
                                                                            value={(certificate.certificate.customerContactName) || ""}
                                                                            onChange={e => onCertificateChange(certificateIndex, "customerContactName", e.target.value, false)}
                                                                            onBlur={e => onCertificateChange(certificateIndex, "customerContactName", e.target.value, true)}
                                                                        />
                                                                    </Col>
                                                                    <Col xxl={4} md={12}>
                                                                        <Label className="form-label">Company Representative Email</Label>
                                                                        <input type="text" maxLength={256} className="form-control" readOnly={certificate.canEditCertifiedParty ? false : true}
                                                                            value={(certificate.certificate.customerContactEmail) || ""}
                                                                            onChange={e => onCertificateChange(certificateIndex, "customerContactEmail", e.target.value, false)}
                                                                            onBlur={e => onCertificateChange(certificateIndex, "customerContactEmail", e.target.value, true)}
                                                                        />
                                                                    </Col>
                                                                    <Col xxl={4} md={12}>
                                                                        <Label className="form-label">Company Representative Phone</Label>
                                                                        <input type="text" maxLength={256} className="form-control" readOnly={certificate.canEditCertifiedParty ? false : true}
                                                                            value={(certificate.certificate.customerContactPhone) || ""}
                                                                            onChange={e => onCertificateChange(certificateIndex, "customerContactPhone", e.target.value, false)}
                                                                            onBlur={e => onCertificateChange(certificateIndex, "customerContactPhone", e.target.value, true)}
                                                                        />
                                                                    </Col>
                                                                    <Col xxl={12} md={12}>
                                                                        <Label className="form-label">Certification Scope{certificate.isCertifiedPartyRequired && <span className="required">*</span>}</Label>
                                                                        <textarea maxLength={4000} className="form-control" rows="5" readOnly={certificate.canEditCertifiedParty ? false : true}
                                                                            value={(certificate.certificationScope) || ""}
                                                                            onChange={e => onRequestCertificateChange(certificateIndex, "certificationScope", e.target.value, false)}
                                                                            onBlur={e => onRequestCertificateChange(certificateIndex, "certificationScope", e.target.value, true)}
                                                                        />
                                                                    </Col>
                                                                    <Col xxl={12} md={12} className="m-0 align-right" style={{textAlign:"right"}}>
                                                                        <Label className="form-label">{certificate.certificationScope && certificate.certificationScope.length || "0"} of 4000</Label>
                                                                    </Col>
                                                                    <Col xxl={12} md={12}>
                                                                        <Label className="form-label">Sub Location(s)</Label>
                                                                    </Col>
                                                                    {certificate.certificate.locations.map(function(item, index){
                                                                        return (
                                                                            <Row className={`gy-1 ${item.isDeleted ? "d-none" : ""}`} key={index}>
                                                                                <Col xxl={11} md={11} className="pe-1">
                                                                                    <input type="text" className="form-control" readOnly={certificate.canEditCertifiedParty ? false : true}
                                                                                        value={item.locationAddress || ""}
                                                                                        onChange={e => onCertificateLocationChange(certificateIndex, index, "locationAddress", e.target.value, false)}
                                                                                        onBlur={e => onCertificateLocationChange(certificateIndex, index, "locationAddress", e.target.value, true)}
                                                                                    />
                                                                                </Col>
                                                                                <Col xxl={1} md={1} className="p-0">
                                                                                    {certificate.canEditCertifiedParty && index === 0 &&
                                                                                    <button type="button" className="btn btn-primary btn-sm me-1 mt-1" title="Add Sub Location"
                                                                                        onClick={() => onCertificateLocationAdd(certificateIndex)}
                                                                                    >
                                                                                        <i className="ri-add-line" />
                                                                                    </button>
                                                                                    }
                                                                                    {certificate.canEditCertifiedParty && index > 0 &&
                                                                                    <button type="button" className="btn btn-danger btn-sm me-1 mt-1" title="Remove Sub Location"
                                                                                        onClick={() => onCertificateLocationChange(certificateIndex, index, "isDeleted", true, false)}
                                                                                    >
                                                                                        <i className="ri-delete-bin-2-line" />
                                                                                    </button>
                                                                                    }
                                                                                </Col>
                                                                            </Row>
                                                                        );
                                                                    })}
                                                                </Row>
                                                            </CardBody>
                                                        </Card>
                                                        }
                                                        {fboState && fboState.showAuditor &&
                                                        <Card className="mb-0 card-light mt-3">
                                                            <CardHeader className="border-0 d-flex align-items-center">
                                                                <h5 className="card-title mb-0 flex-grow-1">Audit Team Information{certificate.isAuditorRequired && <span className="required">*</span>}</h5>
                                                                <div className="flex-shrink-0">
                                                                    <div className="d-flex flex-wrap gap-2">
                                                                        {certificate.canEditAuditor &&
                                                                        <button className="btn btn-primary btn-label"
                                                                            onClick={() => onAuditorAdd(certificateIndex)}
                                                                        >
                                                                            <i className="ri-add-line label-icon align-bottom"></i> Add Auditor
                                                                        </button>
                                                                        }
                                                                    </div>
                                                                </div>
                                                            </CardHeader>
                                                            <CardBody className="border border-dashed border-end-0 border-start-0 card-text">
                                                                <Row className="gy-2">
                                                                    <Col xxl={2} md={12}>
                                                                        <Label className="form-label">Auditor Type{certificate.isAuditorRequired && <span className="required">*</span>}</Label>
                                                                    </Col>
                                                                    <Col xxl={3} md={12}>
                                                                        <Label className="form-label">Auditor Name{certificate.isAuditorRequired && <span className="required">*</span>}</Label>
                                                                    </Col>
                                                                    <Col xxl={2} md={12}>
                                                                        <Label className="form-label">Email</Label>
                                                                    </Col>
                                                                    <Col xxl={4} md={12}>
                                                                        <Label className="form-label">Address</Label>
                                                                    </Col>
                                                                    <Col xxl={1} md={12}>
                                                                        <Label className="form-label">&nbsp;</Label>
                                                                    </Col>
                                                                    {certificate.groupId !== certificate.id && getIntegratedAuditorList(certificate.groupId).map(function(item, index){
                                                                        return (
                                                                            <Row className={`gy-1 ${item.isDeleted ? "d-none" : ""}`} key={index}>
                                                                                <Col xxl={2} md={12}>
                                                                                    <input type="text" className="form-control" readOnly={true}
                                                                                        value={item.auditorType || ""}
                                                                                    />
                                                                                </Col>
                                                                                <Col xxl={3} md={12}>
                                                                                    <input type="text" className="form-control" readOnly={true}
                                                                                        value={(item.auditorList.length > 0 && item.auditorList[0].fullName) || ""}
                                                                                    />
                                                                                </Col>
                                                                                <Col xxl={2} md={12}>
                                                                                    <input type="text" className="form-control" readOnly={true}
                                                                                        value={(item.auditorList.length > 0 && item.auditorList[0].email) || ""}
                                                                                    />
                                                                                </Col>
                                                                                <Col xxl={4} md={12}>
                                                                                    <input type="text" className="form-control" readOnly={true}
                                                                                        value={(item.auditorList.length > 0 && item.auditorList[0].fullAddress) || ""}
                                                                                    />
                                                                                </Col>
                                                                                <Col xxl={1} md={12}>
                                                                                    &nbsp;
                                                                                </Col>
                                                                            </Row>
                                                                        );
                                                                    })}
                                                                    {certificate.auditors && certificate.auditors.filter(x => x.isDeleted === false).length === 0 && <Col xxl={12} md={12}><Label className="form-label">No Auditors added.</Label></Col>}
                                                                    {certificate.auditors && certificate.auditors.map(function(item, index){
                                                                        return (
                                                                            <Row className={`gy-1 ${item.isDeleted ? "d-none" : ""}`} key={index}>
                                                                                <Col xxl={2} md={12}>
                                                                                    <select 
                                                                                        className="form-select" disabled={certificate.canEditAuditor ? false : true}
                                                                                        value={item.auditorType || ""}
                                                                                        onChange={e => onAuditorChange(certificateIndex, index, "auditorType", e.target.value, false)}
                                                                                    >
                                                                                        <option value="">...</option>
                                                                                        <option value="Lead Auditor">Lead Auditor</option>
                                                                                        <option value="Witness Lead Auditor">Witness Lead Auditor</option>
                                                                                        <option value="Co-Auditor">Co-Auditor</option>
                                                                                        <option value="Trainee Auditor">Trainee Auditor</option>
                                                                                        <option value="Technical Expert">Technical Expert</option>   
                                                                                        
                                                                                    </select>
                                                                                </Col>
                                                                                <Col xxl={3} md={12}>
                                                                                    {certificate.canEditAuditor &&
                                                                                    <div className="input-group">
                                                                                        <Lookup
                                                                                            clearButton 
                                                                                            allowNew ={false}
                                                                                            id ={`fldAuditorLookup${index}${certificateIndex}`}
                                                                                            url = {`GetAuditorLookup?index=${index}&certificateIndex=${certificateIndex}&standardId=${certificate.manDay.manDayStandardId || ""}&auditorType=${item.auditorType || ""}`}
                                                                                            defaultSearch={item.auditorId || ""}
                                                                                            placeholder= "Select Auditor..."
                                                                                            labelKey= {option => `${option.fullName || ""}`}
                                                                                            selected = {item.auditorList}
                                                                                            onChange = {(value) => onAuditorUserChange(certificateIndex, index, value)}
                                                                                            renderMenu = {AuditorRenderer}
                                                                                        />
                                                                                    </div>
                                                                                    }
                                                                                    {!certificate.canEditAuditor &&
                                                                                    <input type="text" className="form-control" readOnly={true}
                                                                                        value={(item.auditorList.length > 0 && item.auditorList[0].fullName) || ""}
                                                                                    />
                                                                                    }
                                                                                </Col>
                                                                                <Col xxl={2} md={12}>
                                                                                    <input type="text" className="form-control" readOnly={true}
                                                                                        value={(item.auditorList.length > 0 && item.auditorList[0].email) || ""}
                                                                                    />
                                                                                </Col>
                                                                                <Col xxl={4} md={12}>
                                                                                    <input type="text" className="form-control" readOnly={true}
                                                                                        value={(item.auditorList.length > 0 && item.auditorList[0].fullAddress) || ""}
                                                                                    />
                                                                                </Col>
                                                                                <Col xxl={1} md={12} className="text-end">
                                                                                    {certificate.canEditAuditor &&
                                                                                    <button type="button" className="btn btn-danger btn-sm me-1 mt-1" title="Remove Auditor"
                                                                                        onClick={() => onAuditorChange(certificateIndex, index, "isDeleted", true, false)}
                                                                                    >
                                                                                        <i className="ri-delete-bin-2-line" />
                                                                                    </button>
                                                                                    }
                                                                                </Col>
                                                                            </Row>
                                                                        );
                                                                    })}
                                                                </Row>
                                                            </CardBody>
                                                        </Card>
                                                        }
                                                        {fboState && fboState.showAuditLocation &&
                                                        <Card className="mb-0 card-light mt-3">
                                                            <CardHeader className="border-0 d-flex align-items-center">
                                                                <h5 className="card-title mb-0 flex-grow-1">Audit Locations{certificate.isAuditLocationRequired && <span className="required">*</span>}</h5>
                                                                <div className="flex-shrink-0">
                                                                    <div className="d-flex flex-wrap gap-2">
                                                                        {certificate.canEditAuditLocation &&
                                                                        <button className="btn btn-primary btn-label"
                                                                            onClick={() => onLocationAdd(certificateIndex)}
                                                                        >
                                                                            <i className="ri-add-line label-icon align-bottom"></i> Add Location
                                                                        </button>
                                                                        }
                                                                    </div>
                                                                </div>
                                                            </CardHeader>
                                                            <CardBody className="border border-dashed border-end-0 border-start-0 card-text">
                                                                <Row className="gy-2">
                                                                    <Col xxl={3} md={12}>
                                                                        <Label className="form-label">Location Name</Label>
                                                                    </Col>
                                                                    <Col xxl={hasLocationBothDates(certificate) ? 4 : 6} md={12}>
                                                                        <Label className="form-label">Address</Label>
                                                                    </Col>
                                                                    {hasLocationBothDates(certificate) &&
                                                                    <Fragment>
                                                                        <Col xxl={2} md={12}>
                                                                            <Label className="form-label">Audit Stage 1 Date</Label>
                                                                        </Col>
                                                                        <Col xxl={2} md={12}>
                                                                            <Label className="form-label">Audit Stage 2 Date</Label>
                                                                        </Col>
                                                                    </Fragment>
                                                                    }
                                                                    {!hasLocationBothDates(certificate) &&
                                                                    <Fragment>
                                                                        <Col xxl={2} md={12}>
                                                                            <Label className="form-label">Audit Date</Label>
                                                                        </Col>
                                                                    </Fragment>
                                                                    }
                                                                    <Col xxl={1} md={12}>
                                                                        <Label className="form-label">&nbsp;</Label>
                                                                    </Col>
                                                                    {certificate.groupId !== certificate.id && getIntegratedLocationList(certificate.groupId).map(function(item, index){
                                                                        return (
                                                                            <Row className={`gy-1 ${item.isDeleted ? "d-none" : ""}`} key={index}>
                                                                                <Col xxl={3} md={12}>
                                                                                    <input type="text" maxLength={256} className="form-control" placeholder="location name..." readOnly={true}
                                                                                        value={item.locationName || ""}
                                                                                        onChange={e => onLocationChange(certificateIndex, index, "locationName", e.target.value, false)}
                                                                                    />
                                                                                </Col>
                                                                                <Col xxl={hasLocationBothDates(certificate) ? 4 : 6} md={12}>
                                                                                    <input type="text" maxLength={512} className="form-control" placeholder="location address..." readOnly={true}
                                                                                        value={item.locationAddress || ""}
                                                                                        onChange={e => onLocationChange(certificateIndex, index, "locationAddress", e.target.value, false)}
                                                                                    />
                                                                                </Col>
                                                                                <Col xxl={2} md={12}>
                                                                                    <input type="text" className="form-control" readOnly={true}
                                                                                        value={(getFormattedDate(item.auditDate)) || ""}
                                                                                    />
                                                                                </Col>
                                                                                {hasLocationBothDates(certificate) &&
                                                                                <Col xxl={2} md={12}>
                                                                                    {item.auditDateList.map(function(dateItem, dateIndex){
                                                                                        return (
                                                                                            <Row className={`gy-1 ${dateItem.isDeleted ? "d-none" : ""}`} key={dateIndex}>
                                                                                                <Col xxl={12} md={12} className="p-0">
                                                                                                    <input type="text" className="form-control" readOnly={true}
                                                                                                        value={(getFormattedDate(dateItem.auditDate)) || ""}
                                                                                                    />
                                                                                                </Col>
                                                                                            </Row>
                                                                                        )
                                                                                    })}
                                                                                </Col>
                                                                                }
                                                                                <Col xxl={1} md={12}>
                                                                                    &nbsp;
                                                                                </Col>
                                                                            </Row>
                                                                        );
                                                                    })}
                                                                    {!hasLocations(certificate) && <Col xxl={12} md={12}><Label className="form-label">No Locations added.</Label></Col>}
                                                                    {certificate.locations && certificate.locations.map(function(item, index){
                                                                        return (
                                                                            <Row className={`gy-1 ${item.isDeleted ? "d-none" : ""}`} key={index}>
                                                                                <Col xxl={3} md={12}>
                                                                                    <input type="text" maxLength={256} className="form-control" placeholder="location name..." readOnly={certificate.canEditAuditLocation ? false : true}
                                                                                        value={item.locationName || ""}
                                                                                        onChange={e => onLocationChange(certificateIndex, index, "locationName", e.target.value, false)}
                                                                                        onBlur={e => onLocationChange(certificateIndex, index, "locationName", e.target.value, true)}
                                                                                    />
                                                                                </Col>
                                                                                <Col xxl={hasLocationBothDates(certificate) ? 4 : 6} md={12}>
                                                                                    <input type="text" maxLength={512} className="form-control" placeholder="location address..." readOnly={certificate.canEditAuditLocation ? false : true}
                                                                                        value={item.locationAddress || ""}
                                                                                        onChange={e => onLocationChange(certificateIndex, index, "locationAddress", e.target.value, false)}
                                                                                        onBlur={e => onLocationChange(certificateIndex, index, "locationAddress", e.target.value, true)}
                                                                                    />
                                                                                </Col>
                                                                                <Col xxl={2} md={12}>
                                                                                    {certificate.canEditAuditLocation &&
                                                                                    <Flatpickr className="form-control"
                                                                                        value={getFormattedDateTime(item.auditDate) || ""}
                                                                                        onChange={([date]) => onLocationChange(certificateIndex, index, "auditDate", date)}
                                                                                        options={{
                                                                                            dateFormat: "m/d/Y"
                                                                                        }}
                                                                                    />
                                                                                    }
                                                                                    {!certificate.canEditAuditLocation &&
                                                                                    <input type="text" className="form-control" readOnly={true}
                                                                                        value={(getFormattedDate(item.auditDate)) || ""}
                                                                                    />
                                                                                    }
                                                                                </Col>
                                                                                {hasLocationBothDates(certificate) &&
                                                                                <Col xxl={2} md={12}>
                                                                                    {certificate.canEditAuditLocation && item.auditDateList.map(function(dateItem, dateIndex){
                                                                                        return (
                                                                                            <Fragment key={dateIndex}>
                                                                                                <Row className={`gy-1 ${dateItem.isDeleted ? "d-none" : ""}`} index={dateIndex}>
                                                                                                    <Col xxl={10} md={10} className="pe-1">
                                                                                                        <Flatpickr className="form-control"
                                                                                                            value={getFormattedDateTime(dateItem.auditDate) || ""}
                                                                                                            onChange={([date]) => onLocationDateChange(certificateIndex, index, dateIndex, "auditDate", date)}
                                                                                                            options={{
                                                                                                                dateFormat: "m/d/Y"
                                                                                                            }}
                                                                                                        />
                                                                                                    </Col>
                                                                                                    <Col xxl={2} md={2} className="p-0">
                                                                                                        {dateIndex === 0 &&
                                                                                                        <button type="button" className="btn btn-primary btn-sm me-1 mt-1" title="Add Date"
                                                                                                            onClick={() => onLocationDateAdd(certificateIndex, index)}
                                                                                                        >
                                                                                                            <i className="ri-add-line" />
                                                                                                        </button>
                                                                                                        }
                                                                                                        {dateIndex > 0 &&
                                                                                                        <button type="button" className="btn btn-danger btn-sm me-1 mt-1" title="Remove Date"
                                                                                                            onClick={() => onLocationDateChange(certificateIndex, index, dateIndex, "isDeleted", true, false)}
                                                                                                        >
                                                                                                            <i className="ri-delete-bin-2-line" />
                                                                                                        </button>
                                                                                                        }
                                                                                                    </Col>
                                                                                                </Row>
                                                                                            </Fragment>
                                                                                        );
                                                                                    })}
                                                                                    {!certificate.canEditAuditLocation && item.auditDateList.map(function(dateItem, dateIndex){
                                                                                        return (
                                                                                            <Row className={`gy-1 ${dateItem.isDeleted ? "d-none" : ""}`} key={dateIndex}>
                                                                                                <Col xxl={12} md={12} className="p-0">
                                                                                                    <input type="text" className="form-control" readOnly={true}
                                                                                                        value={(getFormattedDate(dateItem.auditDate)) || ""}
                                                                                                    />
                                                                                                </Col>
                                                                                            </Row>
                                                                                        )
                                                                                    })}
                                                                                </Col>
                                                                                }
                                                                                <Col xxl={1} md={12} className="text-end">
                                                                                    {certificate.canEditAuditLocation &&
                                                                                    <button type="button" className="btn btn-danger btn-sm me-1 mt-1" title="Remove Audit Location"
                                                                                        onClick={() => onLocationChange(certificateIndex, index, "isDeleted", true, false)}
                                                                                    >
                                                                                        <i className="ri-delete-bin-2-line" />
                                                                                    </button>
                                                                                    }
                                                                                </Col>
                                                                            </Row>
                                                                        );
                                                                    })}
                                                                </Row>
                                                            </CardBody>
                                                        </Card>
                                                        }
                                                        {fboState && fboState.showAuditInfo &&
                                                        <Card className="mb-0 card-light mt-3">
                                                            <CardHeader className="border-0 d-flex align-items-center">
                                                                <h5 className="card-title mb-0 flex-grow-1">Audit Information{certificate.isAuditInfoRequired && <span className="required">*</span>}</h5>
                                                            </CardHeader>
                                                            <CardBody className="border border-dashed border-end-0 border-start-0 card-text">
                                                                <Row className="gy-2">
                                                                    <Col xxl={3} md={12}>
                                                                        <Label className="form-label">EA CODE{certificate.isAuditInfoRequired && <span className="required">*</span>}</Label>
                                                                        <input type="text" maxLength={256} className="form-control" readOnly={certificate.canEditAuditInfo ? false : true}
                                                                            value={(certificate.auditInfoEaCode) || ""}
                                                                            onChange={e => onRequestCertificateChange(certificateIndex, "auditInfoEaCode", e.target.value, false)}
                                                                            onBlur={e => onRequestCertificateChange(certificateIndex, "auditInfoEaCode", e.target.value, true)}
                                                                        />
                                                                    </Col>
                                                                    <Col xxl={3} md={12}>
                                                                        <Label className="form-label">NACE{certificate.isAuditInfoRequired && <span className="required">*</span>}</Label>
                                                                        <input type="text" maxLength={256} className="form-control" readOnly={certificate.canEditAuditInfo ? false : true}
                                                                            value={(certificate.auditInfoNace) || ""}
                                                                            onChange={e => onRequestCertificateChange(certificateIndex, "auditInfoNace", e.target.value, false)}
                                                                            onBlur={e => onRequestCertificateChange(certificateIndex, "auditInfoNace", e.target.value, true)}
                                                                        />
                                                                    </Col>
                                                                    <Col xxl={3} md={12}>
                                                                        <Label className="form-label">Category{certificate.isAuditInfoRequired && <span className="required">*</span>}</Label>
                                                                        <input type="text" maxLength={256} className="form-control" readOnly={certificate.canEditAuditInfo ? false : true}
                                                                            value={(certificate.auditInfoCategory) || ""}
                                                                            onChange={e => onRequestCertificateChange(certificateIndex, "auditInfoCategory", e.target.value, false)}
                                                                            onBlur={e => onRequestCertificateChange(certificateIndex, "auditInfoCategory", e.target.value, true)}
                                                                        />
                                                                    </Col>
                                                                    <Col xxl={3} md={12}>
                                                                        <Label className="form-label">Other{certificate.isAuditInfoRequired && <span className="required">*</span>}</Label>
                                                                        <input type="text" maxLength={256} className="form-control" readOnly={certificate.canEditAuditInfo ? false : true}
                                                                            value={(certificate.auditInfoOther) || ""}
                                                                            onChange={e => onRequestCertificateChange(certificateIndex, "auditInfoOther", e.target.value, false)}
                                                                            onBlur={e => onRequestCertificateChange(certificateIndex, "auditInfoOther", e.target.value, true)}
                                                                        />
                                                                    </Col>
                                                                </Row>
                                                            </CardBody>
                                                        </Card>
                                                        }
                                                        {certificate.showCertificate &&
                                                        <Card className="mb-0 card-light mt-3">
                                                            <CardHeader className="border-0 d-flex align-items-center">
                                                                <h5 className="card-title mb-0 flex-grow-1">Certificate Information{certificate.isCertificateRequired && <span className="required">*</span>}</h5>
                                                            </CardHeader>
                                                            <CardBody className="border border-dashed border-end-0 border-start-0 card-text">
                                                                <Row className="gy-2">
                                                                    <Col xxl={3} md={6}>
                                                                        <Label className="form-label">Certificate #{certificate.isCertificateRequired && <span className="required">*</span>}</Label>
                                                                        <input type="text" maxLength={256} className="form-control" readOnly={certificate.canEditCertificateNumber ? false : true}
                                                                            value={certificate.certificate.certificateNumber || ""}
                                                                            onChange={e => onCertificateChange(certificateIndex, "certificateNumber", e.target.value, false)}
                                                                            onBlur={e => onCertificateChange(certificateIndex, "certificateNumber", e.target.value, false)}
                                                                        />
                                                                    </Col>
                                                                    <Col xxl={3} md={6}>
                                                                        <Label className="form-label">Initial Date</Label>
                                                                        <input type="text" className="form-control" readOnly={true}
                                                                            value={getFormattedDate(certificate.certificate.initialDate) || ""}
                                                                        />
                                                                    </Col>
                                                                    <Col xxl={3} md={6}>
                                                                        <Label className="form-label">Certificate Issue Date{certificate.isCertificateRequired && <span className="required">*</span>}</Label>
                                                                        {certificate.canEditCertificateDate &&
                                                                        <Flatpickr className="form-control"
                                                                            value={getFormattedDate(certificate.certificate.certificateIssueDate) || ""}
                                                                            onChange={([date]) => onCertificateChange(certificateIndex, "certificateIssueDate", date, false)}
                                                                            options={{
                                                                                dateFormat: "m/d/Y",
                                                                                maxDate: "today"
                                                                            }}
                                                                        />
                                                                        }
                                                                        {!certificate.canEditCertificateDate &&
                                                                        <input type="text" className="form-control" readOnly={true}
                                                                            value={getFormattedDate(certificate.certificate.certificateIssueDate) || ""}
                                                                        />
                                                                        }
                                                                    </Col>
                                                                    {certificate.certificate.accreditationType !== "Unaccredited" &&
                                                                    <Fragment>
                                                                        <Col xxl={3} md={6}>
                                                                            <Label className="form-label">1st Surveillance Date</Label>
                                                                            <input type="text" className="form-control" readOnly={true}
                                                                                value={getFormattedDate(certificate.certificate.surveillance1Date) || ""}
                                                                            />
                                                                        </Col>
                                                                        <Col xxl={3} md={6}>
                                                                            <Label className="form-label">2nd Surveillance Date</Label>
                                                                            <input type="text" className="form-control" readOnly={true}
                                                                                value={getFormattedDate(certificate.certificate.surveillance2Date) || ""}
                                                                            />
                                                                        </Col>
                                                                    </Fragment>
                                                                    }
                                                                    <Col xxl={3} md={6}>
                                                                        <Label className="form-label">Certificate Expiry Date</Label>
                                                                        <input type="text" className="form-control" readOnly={true}
                                                                            value={getFormattedDate(certificate.certificate.certificateExpiryDate) || ""}
                                                                        />
                                                                    </Col>
                                                                    {certificate.showCertificateLabel &&
                                                                    <Col xxl={12} md={12}>
                                                                        <div className="form-label" dangerouslySetInnerHTML={{__html: certificate.certificate.expiryDateLabel}}></div>
                                                                    </Col>
                                                                    }
                                                                    <Col xxl={12} md={12}>
                                                                        <Label className="form-label">Scope Of Work{certificate.isCertificateRequired && <span className="required">*</span>}</Label>
                                                                        <textarea maxLength={4000} className="form-control" rows="5" readOnly={certificate.canEditCertificateScopeOfWork ? false : true}
                                                                            value={certificate.certificate.scopeOfWork || ""}
                                                                            onChange={e => onCertificateChange(certificateIndex, "scopeOfWork", e.target.value, false)}
                                                                            onBlur={e => onCertificateChange(certificateIndex, "scopeOfWork", e.target.value, true)}
                                                                        />
                                                                    </Col>
                                                                    <Col xxl={12} md={12} className="m-0 align-right" style={{textAlign:"right"}}>
                                                                        <Label className="form-label">{certificate.certificate.scopeOfWork && certificate.certificate.scopeOfWork.length || "0"} of 4000</Label>
                                                                    </Col>
                                                                </Row>
                                                            </CardBody>
                                                        </Card>
                                                        }
                                                        {certificate.showSoa &&
                                                        <Card className="mb-0 card-light mt-3">
                                                            <CardHeader className="border-0 d-flex align-items-center">
                                                                <h5 className="card-title mb-0 flex-grow-1">SoA Information</h5>
                                                            </CardHeader>
                                                            <CardBody className="border border-dashed border-end-0 border-start-0 card-text">
                                                                <Row className="gy-2">
                                                                    <Col xxl={3} md={6}>
                                                                        <Label className="form-label">SoA Version{certificate.isSoaRequired && <span className="required">*</span>}</Label>
                                                                        <input type="text" maxLength={256} className="form-control" readOnly={certificate.canEditSoa ? false : true}
                                                                            value={(certificate.soaVersion) || ""}
                                                                            onChange={e => onRequestCertificateChange(certificateIndex, "soaVersion", e.target.value, false)}
                                                                            onBlur={e => onRequestCertificateChange(certificateIndex, "soaVersion", e.target.value, true)}
                                                                        />
                                                                    </Col>
                                                                    <Col xxl={3} md={6}>
                                                                        <Label className="form-label">SoA Date{certificate.isSoaRequired && <span className="required">*</span>}</Label>
                                                                        {certificate.canEditSoa &&
                                                                        <Flatpickr className="form-control"
                                                                            value={(getFormattedDate(certificate.soaDate)) || ""}
                                                                            onChange={([date]) => onRequestCertificateChange(certificateIndex, "soaDate", date, false)}
                                                                            options={{
                                                                                dateFormat: "m/d/Y",
                                                                                maxDate: "today"
                                                                            }}
                                                                        />
                                                                        }
                                                                        {!certificate.canEditSoa &&
                                                                        <input type="text" className="form-control" readOnly={true}
                                                                            value={(fboState && getFormattedDate(certificate.soaDate)) || ""}
                                                                        />
                                                                        }
                                                                    </Col>
                                                                </Row>
                                                            </CardBody>
                                                        </Card>
                                                        }
                                                        {(certificate.canGenerateMdc || certificate.canGenerateMdcDownload) &&
                                                        <div className="mt-3">
                                                            {certificate.canGenerateMdc && 
                                                            <button className="btn btn-dark btn-label"
                                                                disabled={loading}
                                                                onClick={() => onGenerateMdc(certificate.groupId)}
                                                            >
                                                                <i className="ri-check-double-line label-icon align-bottom"></i> Generate & Attach MDC
                                                            </button>
                                                            }
                                                            {certificate.canGenerateMdcDownload && 
                                                            <button className="btn btn-info btn-label ms-2"
                                                                disabled={loading}
                                                                onClick={() => onGenerateMdcDownload(certificate.groupId)}
                                                            >
                                                                <i className="ri-check-double-line label-icon align-bottom"></i> Generate & Download MDC
                                                            </button>
                                                            }
                                                        </div>
                                                        }
                                                        <IsoServiceDocumentGrid 
                                                            serviceId={-11}
                                                            refId={certificate.groupId}
                                                            refName={"ISO_REQUEST_CERTIFICATE"}
                                                            parentId={fboState.isoRequest.id}
                                                            parentName={"ISO_REQUEST"}
                                                            isProduct={false}
                                                            refreshAction={refreshAction}
                                                            collapsed={"false"}
                                                            canChange={fboState.canSave || certificate.canSave}
                                                            onChange={onChangeDocument}

                                                            showMdcDocument={certificate.showMdcDocument}
                                                            canEditMdcDocument={certificate.canEditMdcDocument}
                                                            isMdcDocumentRequired={certificate.isMdcDocumentRequired}

                                                            showAuditProgramDocument={certificate.showAuditProgramDocument}
                                                            canEditAuditProgramDocument={certificate.canEditAuditProgramDocument}
                                                            isAuditProgramDocumentRequired={certificate.isAuditProgramDocumentRequired}

                                                            showAuditPackageDocument={certificate.showAuditPackageDocument}
                                                            canEditAuditPackageDocument={certificate.canEditAuditPackageDocument}
                                                            isAuditPackageDocumentRequired={certificate.isAuditPackageDocumentRequired}

                                                            showCustomerLogoDocument={certificate.showCustomerLogoDocument}
                                                            canEditCustomerLogoDocument={certificate.canEditCustomerLogoDocument}
                                                            isCustomerLogoDocumentRequired={certificate.isCustomerLogoDocumentRequired}

                                                            showReleaseDocument={certificate.showReleaseDocument}
                                                            canEditReleaseDocument={certificate.canEditReleaseDocument}
                                                            isReleaseDocumentRequired={certificate.isReleaseDocumentRequired}
                                                        />
                                                        {(certificate.canGenerateCertificate || certificate.canGenerateCertificateDownload) &&
                                                        <div className="mt-3">
                                                            {certificate.canGenerateCertificate && 
                                                            <button className="btn btn-dark btn-label"
                                                                disabled={loading}
                                                                onClick={() => onGenerateCertificate(certificate.id)}
                                                            >
                                                                <i className="ri-check-double-line label-icon align-bottom"></i> Generate & Attach Certificate
                                                            </button>
                                                            }
                                                            {certificate.canGenerateCertificateDownload && 
                                                            <button className="btn btn-info btn-label ms-2"
                                                                disabled={loading}
                                                                onClick={() => onGenerateCertificateDownload(certificate.id)}
                                                            >
                                                                <i className="ri-check-double-line label-icon align-bottom"></i> Generate & Download Certificate
                                                            </button>
                                                            }
                                                        </div>
                                                        }
                                                        {certificate.showCertificateDocument &&
                                                        <IsoServiceDocumentGrid 
                                                            serviceId={-12}
                                                            refId={certificate.id}
                                                            refName={"ISO_REQUEST_CERTIFICATE_CERTIFICATE"}
                                                            parentId={fboState.isoRequest.id}   
                                                            parentName={"ISO_REQUEST"}
                                                            isProduct={false}
                                                            refreshAction={refreshAction}
                                                            collapsed={"false"}
                                                            canChange={fboState.canSave || certificate.canSave}
                                                            onChange={onChangeDocument}

                                                            showCertificateDocument={certificate.showCertificateDocument}
                                                            canEditCertificateDocument={certificate.canEditCertificateDocument}
                                                            isCertificateDocumentRequired={certificate.isCertificateDocumentRequired}
                                                        />
                                                        }
                                                    </TabPane>
                                                );
                                            })}
                                        </TabContent>
                                    </Row>
                                </CardBody>
                            </Card>
                            }
                            {/* {fboState && fboState.isoRequest.id > 0 && (fboState.isoRequest.customerId || fboState.isoRequest.certificate.id) &&
                            <Card className="mb-0">
                                <CardHeader className="border-0 d-flex align-items-center">
                                    <h5 className="card-title mb-0 flex-grow-1 cursor-pointer" onClick={() => setRelatedIsoRequestCollapsed(!relatedIsoRequestCollapsed)}>
                                        {relatedIsoRequestCollapsed && <i className="ri-add-box-line align-bottom text-primary"></i>}
                                        {!relatedIsoRequestCollapsed && <i className="ri-checkbox-indeterminate-line align-bottom text-primary"></i>}
                                        Linked / Customer Tickets ({relatedIsoRequestCollapsed ? "Expand" : "Collapse"})
                                    </h5>
                                </CardHeader>
                                <CardBody className="border border-dashed border-end-0 border-start-0 card-text">
                                    <Collapse isOpen={!relatedIsoRequestCollapsed} className="collapse">
                                        <IsoRelatedRequestList
                                            ticketId={fboState.isoRequest.id}
                                            customerId={fboState.isoRequest.customerId}
                                        />
                                    </Collapse>
                                </CardBody>
                            </Card>
                            } */}                            
                            
                            {fboState && fboState.isoRequest.id > 0 &&
                                <IsoServiceDocumentGrid 
                                    serviceId={-1}
                                    refId={fboState.isoRequest.id}
                                    refName={"ISO_REQUEST"}
                                    parentId={fboState.isoRequest.id}
                                    parentName={"ISO_REQUEST"}
                                    isProduct={false}
                                    refreshAction={refreshAction}
                                    collapsed={"false"}
                                    canChange={fboState.canSave}
                                    onChange={onChangeDocument}

                                    showApplicationDocument={fboState.showApplicationDocument}
                                    canEditApplicationDocument={fboState.canEditApplicationDocument}
                                    isApplicationDocumentRequired={fboState.isApplicationDocumentRequired}

                                    showProposalDocument={fboState.showProposalDocument}
                                    canEditProposalDocument={fboState.canEditProposalDocument}
                                    isProposalDocumentRequired={fboState.isProposalDocumentRequired}

                                    showContractDocument={fboState.showContractDocument}
                                    canEditContractDocument={fboState.canEditContractDocument}
                                    isContractDocumentRequired={fboState.isContractDocumentRequired}

                                    showInvoiceDocument={fboState.showInvoiceDocument}
                                    canEditInvoiceDocument={fboState.canEditInvoiceDocument}
                                    isInvoiceDocumentRequired={fboState.isInvoiceDocumentRequired}

                                    showTtDocument={fboState.showTtDocument}
                                    canEditTtDocument={fboState.canEditTtDocument}
                                    isTtDocumentRequired={fboState.isTtDocumentRequired}

                                    
                                />
                            }

                            {fboState && fboState.isoRequest.id > 0 &&
                                <CommentGrid refId={fboState.isoRequest.id} refName="ISO_REQUEST" onCommentAdd={reloadAction} />
                            }
                        </Col>
                        
                        {fboState && fboState.isoRequest.id > 0 &&
                        <Col lg={3}>
                            <ActionList id={fboState.isoRequest.id} name={"ISO_REQUEST"} refreshAction={refreshAction} />
                        </Col>
                        }

                        <Modal tabIndex="-1" size="xl" isOpen={showAddCertificateModal} toggle={hideAddCertificateModal} centered={true}>
                            <ModalHeader>
                                Add Standard
                            </ModalHeader>
                            <ModalBody>
                                <CardLoader loading={loadingLocal} />
                                <Row className="gy-2">
                                    <Col xxl={6} md={6}>
                                        <Label className="form-label">Accreditation Type</Label>
                                        <select className="form-select"
                                            value={newAccreditationType}
                                            onChange={e => {
                                                setNewAccreditationType(e.target.value);
                                                setNewManDayStandardId("");
                                            }}
                                        >
                                            <option value={""}>...</option>
                                            <option value={"SAC"}>SAC</option>
                                            <option value={"Hellas"}>Hellas</option>
                                            <option value={"Vienna"}>Vienna</option>
                                            <option value={"Unaccredited"}>Unaccredited</option>
                                        </select>
                                    </Col>
                                    <Col xxl={6} md={6}>
                                        <Label className="form-label">Man Day Standard</Label>
                                        <Select
                                            placeholder="..."
                                            isClearable={true}
                                            isSearchable={true}
                                            value={fboState && fboState.manDayStandardList.find(x => x.id.toString() === newManDayStandardId?.toString()) || null}
                                            onChange={option => setNewManDayStandardId(option?.id ?? "")}
                                            options={fboState && fboState.manDayStandardList.filter(x => x.accreditationType == newAccreditationType) || []}
                                            getOptionValue={option => option.id.toString()}
                                            getOptionLabel={option => option.standardShortName}
                                        />
                                    </Col>
                                    <Col xxl={6} md={6}>
                                        <Label className="form-label">Request Type<span className="required">*</span></Label>
                                        <select className="form-select"
                                            value={newRequestType}
                                            onChange={e => setNewRequestType(e.target.value)}
                                        >
                                            <option value={""}>...</option>
                                            {fboState && fboState.requestTypeList.map(function(item, index){
                                                return (
                                                    <option key={index} value={item.code}>{item.description}</option>
                                                );
                                            })}
                                        </select>
                                    </Col>
                                    {newRequestType == "Other Audit" &&
                                    <Col xxl={6} md={6}>
                                        <Label className="form-label">Other Audit Name<span className="required">*</span></Label>
                                        <input type="text" className="form-control"
                                            value={newRequestTypeOther}
                                            onChange={e => setNewRequestTypeOther(e.target.value)}
                                        />
                                    </Col>
                                    }
                                    <Col xxl={6} md={6}>
                                        <Label className="form-label">Certificate Number{newRequestType != "Initial Audit" && <span className="required">*</span>}</Label>
                                        <input className="form-control"
                                            value={newCertificateNumber}
                                            onChange={e => setNewCertificateNumber(e.target.value)}
                                        />
                                    </Col>
                                </Row>
                            </ModalBody>
                            <ModalFooter>
                                <button type="button" className="btn btn-primary btn-label" onClick={onAddCertificateClick} disabled={loadingLocal}>
                                    <i className="ri-save-line label-icon align-bottom"></i> Add Standard
                                </button>
                                <button type="button" className="btn btn-danger btn-label" data-dismiss="modal" onClick={hideAddCertificateModal} disabled={loadingLocal}>
                                    <i className="ri-close-line label-icon align-bottom"></i> Close
                                </button>
                            </ModalFooter>
                        </Modal>

                        <ConfirmModal message={"Are you sure you want to Remove the Certificate from the Ticket?"} show={showRemoveCertificateModal} onCloseClick={onCloseModalClick} onYesClick={onSaveRemoveCertificate} />
                        
                        <ConfirmModal message={"Are you sure you want to \"Submit\" the ISO Ticket?"} show={showSubmitModal} onCloseClick={onCloseModalClick} onYesClick={onSaveIsoRequest} />
                        <ConfirmModal message={"Are you sure you want to submit the ISO Ticket for \"Sales Action\"?"} show={showSalesActionModal} onCloseClick={onCloseModalClick} onYesClick={onSaveIsoRequest} />
                        <ConfirmModal message={"Are you sure you want to return the ISO Ticket to \"Certificate Admin\"?"} show={showNewModal} onCloseClick={onCloseModalClick} onYesClick={onSaveIsoRequest} />
                        <ConfirmModal message={"Are you sure you want to submit the ISO Ticket to \"Calculate Man Days\"?"} show={showCalculateManDaysModal} onCloseClick={onCloseModalClick} onYesClick={onSaveIsoRequest} />
                        <ConfirmModal message={"Are you sure you want to submit the ISO Ticket for \"Scheduling\"?"} show={showSchedulingModal} onCloseClick={onCloseModalClick} onYesClick={onSaveIsoRequest} />
                        <ConfirmModal message={"Are you sure you want to submit the ISO Ticket for \"Audit\"?"} show={showAuditInProgressModal} onCloseClick={onCloseModalClick} onYesClick={onSaveIsoRequest} />
                        <ConfirmModal message={"Are you sure you want to submit the ISO Ticket for \"Document Review\"?"} show={showDocumentReviewModal} onCloseClick={onCloseModalClick} onYesClick={onSaveIsoRequest} />
                        <ConfirmModal message={"Are you sure you want to submit the ISO Ticket for \"Technical Review\"?"} show={showTechnicalReviewModal} onCloseClick={onCloseModalClick} onYesClick={onSaveIsoRequest} />
                        <ConfirmModal message={"Are you sure you want to submit the ISO Ticket for \"Decision Making\"?"} show={showDecisionMakingModal} onCloseClick={onCloseModalClick} onYesClick={onSaveIsoRequest} />
                        <ConfirmModal message={"Are you sure you want to submit the ISO Ticket for \"Certificate Generation\"?"} show={showCertificateGenerationModal} onCloseClick={onCloseModalClick} onYesClick={onSaveIsoRequest} />
                        <ConfirmModal message={"Are you sure you want to mark the ISO Ticket as \"Completed\"?"} show={showCompletedModal} onCloseClick={onCloseModalClick} onYesClick={onSaveIsoRequest} />
                        <ConfirmModal message={"Are you sure you want to \"Close\" the ISO Ticket?"} show={showClosedModal} onCloseClick={onCloseModalClick} onYesClick={onSaveIsoRequest} />
                        <ConfirmModal message={"Are you sure you want to \"Abort\" the ISO Ticket?"} show={showAbortedModal} onCloseClick={onCloseModalClick} onYesClick={onSaveIsoRequest} />
                        <ConfirmModal message={"Are you sure you want to \"Reset To Draft\" the ISO Ticket?"} show={showResetToDraftModal} onCloseClick={onCloseModalClick} onYesClick={onSaveIsoRequest} />
                        <ConfirmModal message={"Are you sure you want to Assign the ISO Ticket?"} show={showAssignMeModal} onCloseClick={onCloseModalClick} onYesClick={onAssignMeTicket} />

                        <ConfirmModalAdvanced show={showProceedWithoutPaymentModal} onCloseClick={onCloseModalClick} onYesClick={onSaveProceedWithoutPayment}>
                            <div className="text-center pb-2">Are you sure you want to Mark the ticket to "Proceed without Payment"?.</div>
                            <Col xxl={12} md={12} className="pb-2">
                                <Label className="form-label">Enter Any Comments</Label>
                                <textarea className="form-control" rows="5"
                                    value={currentMessage || ""}
                                    onChange={e => setCurrentMessage(e.target.value)}
                                />
                            </Col>
                        </ConfirmModalAdvanced>

                        <ConfirmModalAdvanced show={showNotifyProceedWithoutPaymentModal} onCloseClick={onCloseModalClick} onYesClick={onSaveNotifyProceedWithoutPayment}>
                            <div className="text-center pb-2">Are you sure you want to Notify Manager to Mark the ticket to "Proceed without Payment"?.</div>
                            <Col xxl={12} md={12} className="pb-2">
                                <Label className="form-label">Enter Any Comments</Label>
                                <textarea className="form-control" rows="5"
                                    value={currentMessage || ""}
                                    onChange={e => setCurrentMessage(e.target.value)}
                                />
                            </Col>
                        </ConfirmModalAdvanced>

                        <ConfirmModalAdvanced size="lg" show={showGenerateCertificateModal} onCloseClick={onCloseModalClick} onYesClick={onSaveGenerateCertificate}>
                            {generateCertificateErrorMessages.map(function(item, index){
                                return (
                                    <div key={index} className="d-flex">
                                        <div className="flex-shrink-1">
                                            <i className="ri-error-warning-fill align-bottom text-warning me-1"></i>
                                        </div>
                                        <div className="flex-grow-1">{item}.</div>
                                    </div>
                                );
                            })}
                            <div className="text-center pt-2 pb-2">Are you sure you want to Generate the "Certificate"?</div>
                        </ConfirmModalAdvanced>

                        <ConfirmModalAdvanced size="lg" show={showGenerateCertificateDownloadModal} onCloseClick={onCloseModalClick} onYesClick={onSaveGenerateCertificateDownload}>
                            {generateCertificateErrorMessages.map(function(item, index){
                                return (
                                    <div key={index} className="d-flex">
                                        <div className="flex-shrink-1">
                                            <i className="ri-error-warning-fill align-bottom text-warning me-1"></i>
                                        </div>
                                        <div className="flex-grow-1">{item}.</div>
                                    </div>
                                );
                            })}
                            <div className="text-center pt-2 pb-2">Are you sure you want to Download the "Certificate"?</div>
                        </ConfirmModalAdvanced>

                        <ConfirmModal message={"Are you sure you want to Generate the MDC Document?"} show={showGenerateMdcModal} onCloseClick={onCloseModalClick} onYesClick={onSaveGenerateMdc} />
                        <ConfirmModal message={"Are you sure you want to Download the MDC Document?"} show={showGenerateMdcDownloadModal} onCloseClick={onCloseModalClick} onYesClick={onSaveGenerateMdcDownload} />
                        <ConfirmModal message={`All the required information is provided on this ticket. Do you want to move the Ticket to \"${autoStatusNextStatus}\"?`} show={showAutoStatusChangeModal} onCloseClick={onCloseModalClick} onYesClick={onSaveIsoRequest} />

                        <ConfirmModal message={"Are you sure you want to Remove the Invoice Linking to the Ticket?"} show={showRemoveInvoiceModal} onCloseClick={onCloseModalClick} onYesClick={onSaveRemoveInvoice} />
                        
                        <Modal tabIndex="-1" size="xl" isOpen={showInvoiceViewModal} toggle={hideInvoiceViewModal} centered={true}>
                            <ModalHeader>Invoice Information</ModalHeader>
                            <ModalBody>
                                <CardLoader loading={loadingInvoice} />
                                <Row className="gy-2">
                                    <Col xxl={3} md={6}>
                                        <Label className="form-label">Assigned To</Label>
                                        <input type="text" className="form-control" readOnly={true}
                                            value={(invoiceFBO && invoiceFBO.assignedUserName) || ""}
                                        />
                                    </Col>
                                    <Col xxl={3} md={6}>
                                        <Label className="form-label">Total Amount</Label>
                                        <div className="form-control"><MyNumberRenderer value={(invoiceFBO && invoiceFBO.totalAmount) || ""} /></div>
                                    </Col>
                                    <Col xxl={3} md={6}>
                                        <Label className="form-label">Status</Label>
                                        <input type="text" className="form-control" readOnly={true}
                                            value={(invoiceFBO && invoiceFBO.status) || ""}
                                        />
                                    </Col>
                                    <Col xxl={3} md={6}>&nbsp;</Col>
                                    <Col xxl={3} md={6}>
                                        <Label className="form-label">Billing Account</Label>
                                        <input type="text" className="form-control" readOnly={true}
                                            value={(invoiceFBO && invoiceFBO.billingAccount) || ""}
                                        />
                                    </Col>
                                    <Col xxl={3} md={6}>
                                        <Label className="form-label">Billing City</Label>
                                        <input type="text" className="form-control" readOnly={true}
                                            value={(invoiceFBO && invoiceFBO.billingAddressCity) || ""}
                                        />
                                    </Col>
                                    <Col xxl={3} md={6}>
                                        <Label className="form-label">Billing State</Label>
                                        <input type="text" className="form-control" readOnly={true}
                                            value={(invoiceFBO && invoiceFBO.billingAddressState) || ""}
                                        />
                                    </Col>
                                    <Col xxl={3} md={6}>
                                        <Label className="form-label">Billing Country</Label>
                                        <input type="text" className="form-control" readOnly={true}
                                            value={(invoiceFBO && invoiceFBO.billingAddressCountry) || ""}
                                        />
                                    </Col>
                                    <Col xxl={3} md={6}>
                                        <Label className="form-label">Billing Contact</Label>
                                        <input type="text" className="form-control" readOnly={true}
                                            value={(invoiceFBO && invoiceFBO.billingContact) || ""}
                                        />
                                    </Col>
                                    <Col xxl={3} md={6}>
                                        <Label className="form-label">Shipping City</Label>
                                        <input type="text" className="form-control" readOnly={true}
                                            value={(invoiceFBO && invoiceFBO.shippingAddressCity) || ""}
                                        />
                                    </Col>
                                    <Col xxl={3} md={6}>
                                        <Label className="form-label">Shipping State</Label>
                                        <input type="text" className="form-control" readOnly={true}
                                            value={(invoiceFBO && invoiceFBO.shippingAddressState) || ""}
                                        />
                                    </Col>
                                    <Col xxl={3} md={6}>
                                        <Label className="form-label">Shipping Country</Label>
                                        <input type="text" className="form-control" readOnly={true}
                                            value={(invoiceFBO && invoiceFBO.shippingAddressCountry) || ""}
                                        />
                                    </Col>
                                    <Col xxl={3} md={6}>
                                        <Label className="form-label">Currency</Label>
                                        <select className="form-select" disabled={true}
                                            value={(fboState && fboState.isoRequest.currency) || ""}
                                        >
                                            <option value={""}>...</option>
                                            <option value="AED">UAE Dirham</option>
                                            <option value="CNY">China Yuan</option>
                                            <option value="EUR">Euro</option>
                                            <option value="USD">USA Dollar</option>
                                            <option value="LKR">Sri Lanka Rupee</option>
                                            <option value="EGP">Egypt Pound</option>
                                            <option value="SAR">Saudi Riyal</option>
                                            <option value="INR">India Rupee</option>
                                        </select>
                                    </Col>
                                </Row>
                            </ModalBody>
                            <ModalFooter>
                                <button type="button" className="btn btn-danger btn-label" data-dismiss="modal" onClick={hideInvoiceViewModal}>
                                    <i className="ri-close-line label-icon align-bottom"></i> Close
                                </button>
                            </ModalFooter>
                        </Modal>
                    </Row>
                </Container>
            </div>
        </Fragment>
    );
}

export default IsoRequestEditScreen;